<template>
  <div :class="{ 'lmg-shop': isTargetShop }">
    <v-main>
      <v-container>
        <!-- ร้านที่ตั้ง requireFriend: ต้องเป็นเพื่อนกับ OA ก่อนถึงจะสมัครได้ -->
        <div v-if="friendGate" class="friend-gate">
          <div class="friend-gate__card">
            <v-img v-if="shopInfo && shopInfo.logo" :src="shopInfo.logo" max-width="96" max-height="96" contain class="mx-auto mb-3"></v-img>
            <div class="friend-gate__title">{{ $i18n.locale === 'th' ? 'เพิ่มเพื่อนก่อนสมัครสมาชิก' : 'Add us as a friend first' }}</div>
            <div class="friend-gate__text">{{ $i18n.locale === 'th' ? 'กรุณาเพิ่มเพื่อน LINE ของ ' + (shopInfo && (shopInfo.title || shopInfo.name) || shopname) + ' แล้วกลับมาที่หน้านี้' : 'Please add our LINE account, then come back to this page' }}</div>
            <v-btn block rounded color="#06C755" class="white--text mb-2" @click="openAddFriend">
              {{ $i18n.locale === 'th' ? 'เพิ่มเพื่อน' : 'Add friend' }}
            </v-btn>
            <v-btn block rounded outlined :loading="friendChecking" @click="checkFriend">
              {{ $i18n.locale === 'th' ? 'เพิ่มแล้ว ตรวจอีกครั้ง' : "I've added, check again" }}
            </v-btn>
          </div>
        </div>
        <v-row justify="center">
          <v-col cols="12" class="pa-0" v-if="showRegis">
            <div v-if="shopStatus !== 'inactive'">
              <!-- <v-img height="100%" :src="require('@/assets/bgBetask.jpeg')">
              </v-img> -->
              <div v-if="isTargetShop" style="height: 200px;background-color:#FFA300">
                <div class="pt-2" style="text-align: end;">
                  <v-chip class="mr-2" @click="changlangue()"
                    :style="isTargetShop ? { color: '#000000', backgroundColor: '#B3B3B3' } : {}">
                    <v-avatar left>
                      <v-img :src="$i18n.locale === 'th' ? thai : eng"></v-img>
                    </v-avatar>
                    {{ $i18n.locale === 'th' ? 'TH' : 'EN' }}
                  </v-chip>
                </div>
                <div style="text-align: center;" v-if="profile.pictureUrl && profile.displayName">
                  <v-avatar style="height: 86px;width: 86px;">
                    <img :src="isTargetShop && shopInfo && shopInfo.logo ? shopInfo.logo : profile.pictureUrl" alt="LOGO" />
                  </v-avatar>
                  <p class="mt-2" v-if="profile.displayName" :style="{ 'color': '#fff' }">{{ isTargetShop && shopInfo && shopInfo.title ? shopInfo.title : profile.displayName
                  }}</p>
                </div>
                <div style="display: flex;justify-content: center;" v-if="!profile.pictureUrl && !profile.displayName">
                  <v-avatar style="height: 120px;width: 120px;">
                    <v-img contain
                      :src="pictureUrlPreview ? pictureUrlPreview : 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'"
                      alt="John" />
                  </v-avatar>
                </div>
                <div style="text-align: center;" class="mt-2"
                  v-if="!this.profile.pictureUrl && (shopId === 'U97dd281445cde30a599a5f5515a4e937' || shopId === 'U60f3a4215c86a978d5f6191292ad0109' || shopId === 'Ud4b2ccbf4ca8c45196c1b0379629454f' || 'U43e7e7332135fa3253d4a1385a8a89ce')">
                  <v-btn small rounded @click="chooseImage"><v-icon>mdi-camera</v-icon>{{ $t("message.changePicture")
                  }}</v-btn>
                  <input style="display: none" class="file-input" ref="fileInput" type="file" @input="onSelectFile" />
                </div>
              </div>

              <div v-else class="pa-4 pt-4"
                :style="'z-index: 0;position: relative;min-height:185px;' + (registerCover ? 'background:' + registerCover + ';' : 'background-image: linear-gradient(0deg,' + $bgColor + '0%,' + $bgColor2 + '100%);')">
                <div v-if="!registerCover"
                  :style="'height: 143px;background-color:' + $bgColor2 + ';width: 143px;border-radius: 100px;position: absolute;z-index: -1;right: 14px;top: -52px;'">
                </div>
                <div v-if="!registerCover"
                  :style="'height: 90px;background-color:' + $bgColor2 + ';width: 45px;border-top-left-radius: 110px;border-bottom-left-radius: 110px;position: absolute;z-index: -1;right: 1px;top: 29px;'">
                </div>
                <div v-if="!registerCover"
                  :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 17px;top: 58px;'">
                </div>
                <div v-if="!registerCover"
                  :style="'height: 89px;background-color:' + $bgColor3 + ';width: 89px;border-radius: 100px;position: absolute;z-index: -1;right: 73px;top: 70px;'">
                </div>
                <div style="display:flex;justify-content: space-between;z-index: 1;"></div>
                <div style="text-align: end;">
                  <v-chip class="mr-2" @click="changlangue()"
                    :style="isTargetShop ? { color: '#000000', backgroundColor: '#f2f2f2' } : {}">
                    <v-avatar left>
                      <v-img :src="$i18n.locale === 'th' ? thai : eng"></v-img>
                    </v-avatar>
                    {{ $i18n.locale === 'th' ? 'TH' : 'EN' }}
                  </v-chip>
                </div>
                <div style="text-align: center;" v-if="profile.pictureUrl && profile.displayName">
                  <v-avatar style="height: 86px;width: 86px;" :color="sheetForm && shopInfo && shopInfo.logo ? '#fff' : undefined">
                    <img :src="sheetForm && shopInfo && shopInfo.logo ? shopInfo.logo : profile.pictureUrl" :style="sheetForm && shopInfo && shopInfo.logo ? 'object-fit: contain;' : ''" alt="John" />
                  </v-avatar>
                  <p class="mt-2" v-if="profile.displayName" :style="{ 'color': registerCover ? '#fff' : computedStyle, 'font-weight': registerCover ? 'bold' : undefined, 'font-size': registerCover ? '18px' : undefined }">{{ sheetForm && shopInfo ? (shopInfo.title || shopInfo.name) : profile.displayName
                  }}</p>
                </div>
                <div style="display: flex;justify-content: center;" v-if="!profile.pictureUrl && !profile.displayName">
                  <v-avatar style="height: 120px;width: 120px;">
                    <v-img contain
                      :src="pictureUrlPreview ? pictureUrlPreview : 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'"
                      alt="John" />
                  </v-avatar>
                </div>
                <div style="text-align: center;" class="mt-2"
                  v-if="!this.profile.pictureUrl && (shopId === 'U97dd281445cde30a599a5f5515a4e937' || shopId === 'U60f3a4215c86a978d5f6191292ad0109' || shopId === 'Ud4b2ccbf4ca8c45196c1b0379629454f' || 'U43e7e7332135fa3253d4a1385a8a89ce')">
                  <v-btn small rounded @click="chooseImage"><v-icon>mdi-camera</v-icon>{{ $t("message.changePicture")
                  }}</v-btn>
                  <input style="display: none" class="file-input" ref="fileInput" type="file" @input="onSelectFile" />
                </div>
              </div>

              <div>
                <!-- <v-row>
                  <v-col cols="2" class="text-center">
                    <v-avatar>
                      <img :src="profile.pictureUrl" alt="John" />
                    </v-avatar>
                  </v-col>
                  <v-col cols="10">
                    <v-alert color="primary" dark border="left" prominent>
                      สวัสดี คุณ {{ profile.displayName }}
                    </v-alert>
                  </v-col>
                </v-row> -->
                <v-container>
                  <v-form ref="form_add" v-model="validAdd" lazy-validation :class="{ 'sheet-form-order': sheetForm }">
                    <v-row
                      v-if="theme.barCodeData === 'True' && shopId !== 'U43e7e7332135fa3253d4a1385a8a89ce' && !$isTargetShop()">
                      <v-col cols="12" class="pb-0 pt-1">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold', display: 'flex' }">
                          <p class="mb-0 mr-1" style="color:red">**** </p>{{ shopId ===
                            'U97dd281445cde30a599a5f5515a4e937' ? $t("message.memberIdFill") : shopId ===
                              'U60f3a4215c86a978d5f6191292ad0109' ? 'เลขที่โควต้า' : shopId ===
                                'Ub067d158c52aaaec79b67cfc997fda79' ? $t("message.contract") : $t("message.plsFillId") }}
                        </div>
                        <!-- <div class="mb-2" v-if="shopId === 'Ub067d158c52aaaec79b67cfc997fda79'">ตัวอย่างเลขที่สัญญา AA111-1234</div> -->
                        <v-text-field outlined
                          v-mask="shopId === 'U97dd281445cde30a599a5f5515a4e937' ? '##-######-##' : ''"
                          :rules="[rules.required]" :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" hide-details required dense
                          v-model="form.barcodeNum"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="sheet-order-name">
                      <v-col cols="12" class="pb-0 pt-1">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ this.$route.query.shopId !==
                          'SD_1737957295593' ? this.$isEventShop(this.$route.query.shopId) ?
                          (sheetForm ? $t("message.nameSurname") : $t("message.nameSurnameStampCGS")) : this.$route.query.shopId ===
                            'Ub067d158c52aaaec79b67cfc997fda79' ? $t("message.nameSurnameEazyCar") :
                            $t("message.nameSurname") : 'ชื่อบริษัท' }}</div>
                        <v-text-field outlined :rules="[rules.required]" :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" hide-details
                          required dense v-model="form.nameCustomer"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row class="sheet-order-tel"
                      v-if="this.$route.query.shopId !== 'U5bad3d6f53733785f626ceaeaad539f5' && this.$route.query.shopId !== 'SD_1737957295593' && this.$route.query.shopId !== 'SD_1749094171700'">
                      <v-col cols="12" class="pb-0">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ this.$route.query.shopId ===
                          $shopNameData.chubb ? $t("message.empId") : this.$isEventShop(this.$route.query.shopId) ? (sheetForm ? $t("message.tel") : $t("message.telCGS")) : this.$route.query.shopId ===
                              'Ub067d158c52aaaec79b67cfc997fda79' ? $t("message.tel") + ' ' + $t("message.mustBeMatchConNo")
                          : $t("message.tel") }}</div>
                          <!-- {{ this.$route.query.shopId === $shopNameData.chubb  }}
                          {{ this.$route.query.shopId+''+ isTargetShop }} -->
                        <v-text-field v-if="$route.query.shopId === $shopNameData.chubb" outlined
                          :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" :rules="[rules.empId]" placeholder="Ex. AA12345"
                          hide-details required dense v-model="form.tel"></v-text-field>
                        <v-text-field v-else outlined :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" v-mask="'###-###-####'"
                          :rules="[rules.counterTel]" :placeholder="''" hide-details required dense
                          v-model="form.tel"></v-text-field>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="!hiddenSystemFields.includes('birthDay') && this.$route.query.shopId !== 'U5bad3d6f53733785f626ceaeaad539f5' && this.$route.query.shopId !== 'SD_1737957295593' && this.$route.query.shopId !== 'SD_1749094171700' && this.$route.query.shopId !== 'SD_1748673982745'">
                      <v-col cols="12">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ $t("message.birtDay") }}</div>
                        <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                          transition="scale-transition" offset-y min-width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field v-model="form.bdDate" outlined v-bind="attrs"
                              :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" readonly dense :rules="[rules.required]" hide-details
                              required v-on="on" append-icon="mdi-calendar"></v-text-field>
                          </template>
                          <v-date-picker ref="picker1" v-model="form.bdDate" :active-date.sync="activePicker"
                            :max="new Date().toISOString().substr(0, 10)" min=" 1950-01-01"
                            :locale="$i18n.locale === 'th' ? 'th-th' : 'en-en'" @change="save1"></v-date-picker>
                        </v-menu>
                      </v-col>
                    </v-row>
                    <v-row
                      v-if="!hiddenSystemFields.includes('gender') && this.$route.query.shopId !== 'U5bad3d6f53733785f626ceaeaad539f5' && this.$route.query.shopId !== $shopNameData.chubb && this.$route.query.shopId !== 'SD_1737957295593' && this.$route.query.shopId !== 'SD_1749094171700'">
                      <v-col cols="12">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ $t("message.selectGender") }}
                        </div>
                      </v-col>
                    </v-row>
                    <v-select
                      v-if="!hiddenSystemFields.includes('gender') && this.$route.query.shopId !== 'U5bad3d6f53733785f626ceaeaad539f5' && this.$route.query.shopId !== $shopNameData.chubb && this.$route.query.shopId !== 'SD_1737957295593' && this.$route.query.shopId !== 'SD_1749094171700'"
                      :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" v-model="gender"
                      :items="$i18n.locale === 'th' ? this.$route.query.shopId === 'U97dd281445cde30a599a5f5515a4e937' ? choiceGenderKke : choiceGender : this.$route.query.shopId === 'U97dd281445cde30a599a5f5515a4e937' ? choiceGenderEngKke : choiceGenderEng"
                      :rules="[rules.required]" hide-details outlined dense required></v-select>
                    <!-- <v-row v-if="emailCheckStatus">
                      <v-col cols="12" class="pb-0">
                        <div class=" mb-2 " style="color: #8f8c8c;font-weight: bold;">{{ 'email' }}</div>
                        <v-text-field
                          outlined
                          style="background-color: #EFEFEF00;"
                          :rules="[rules.email]"
                          hide-details
                          required
                          dense
                          v-model="form.email"
                        ></v-text-field>
                      </v-col>
                    </v-row> -->
                    <v-row v-for="(item, i) in customFeild.filter(a => a.showCard === 'True')" :key="i" class="mt-0 sheet-order-custom">
                      <v-col cols="12" class="pb-0 mt-2 mb-2" v-if="item.fieldType === 'text'">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ item.fieldName }}</div>
                        <v-text-field outlined :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" hide-details dense
                          :rules="item.requiredField === 'True' ? [rules.required] : true"
                          v-model="valueCustomFeild[i].value"></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pb-0 mt-2 mb-2" v-if="item.fieldType === 'email' && emailCheckStatus">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ item.fieldName }}</div>
                        <v-text-field outlined :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" hide-details dense required
                          :rules="item.requiredField === 'True' ? [rules.email] : false"
                          v-model="form.email"></v-text-field>
                      </v-col>
                      <v-col cols="12" class="pb-0 mt-2 mb-2" v-if="item.fieldType === 'checkbox'">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ item.fieldName }}</div>
                        <!-- <div >{{item2}} -->
                        <v-checkbox v-for="(item2, index) in JSON.parse(item.answer)" :key="index" :label="item2"
                          :value="item2" hide-details @change="pushValueCheckbox(i, item2)"></v-checkbox>
                        <!-- </div> -->
                      </v-col>
                      <v-col cols="12" class="pb-0 mt-2 mb-2" v-if="item.fieldType === 'radio'">
                        <div :class="item.ChoseAnotherAnswer !== 'True' ? 'mb-1' : 'd-flex justify-space-between'"
                          :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">
                          <div style="text-wrap: wrap;">{{ item.fieldName }}</div>
                          <div style="text-decoration: underline;" v-if="item.ChoseAnotherAnswer === 'True'"
                            @click="rePick(i)">เลือกใหม่
                          </div>
                        </div>
                        <v-select v-if="item.ChoseAnotherAnswer !== 'True'" outlined dense
                          :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" :rules="[rules.required]"
                          @change="checkAnother(valueCustomFeild[i].value, i)" hide-details
                          v-model="valueCustomFeild[i].value"
                          :items="item.anotherAnswer === 'True' ? checkAnotherAnswer(item.answer) : JSON.parse(item.answer)"></v-select>
                        <v-text-field v-if="item.ChoseAnotherAnswer === 'True'" outlined dense label="กรุณากรอกข้อมูล"
                          :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" :rules="[rules.required]" pre hide-details
                          v-model="valueCustomFeild[i].value"></v-text-field>
                        <!-- <v-text-field
                          outlined
                          style="background-color: #EFEFEF00;"
                          hide-details
                          dense
                          :rules="item.requiredField === 'True' ? [rules.required] : true"
                          v-model="valueCustomFeild[i].value"
                        ></v-text-field> -->
                      </v-col>
                    </v-row>
                    <!-- <div  class=" mb-4 " style="display: flex;justify-content:space-around">
                      <div @click="selectGender('male')" :class="(this.gender !== null && this.gender === 'male') ? 'activeGender': 'btnJa'">
                        <div><v-icon class="iconify" style="margin-right: 6px" data-icon="mdi:face-man"></v-icon>ชาย</div>
                      </div>
                      <div @click="selectGender('female')" :class="(this.gender !== null && this.gender === 'female') ? 'activeGender': 'btnJa'">
                        <div><v-icon class="iconify" style="margin-right: 6px" data-icon="mdi:face-woman"></v-icon>หญิง</div>
                      </div>
                      <div @click="selectGender('lgbt')" :class="(this.gender !== null && this.gender === 'lgbt') ? 'activeGender': 'btnJa'">
                        <div><v-icon class="iconify" style="margin-right: 6px" data-icon="mdi:gender-male-female"></v-icon>LGBT</div>
                      </div>
                    </div> -->
                    <v-row v-if="theme.friendGetFriendStatus === 'True'">
                      <v-col cols="12" class="pb-0 mt-2 mb-2">
                        <div class=" mb-2 " :style="{ color: '#8f8c8c', fontWeight: isTargetShop ? '100' : 'bold' }">{{ $t("message.referralCode") }}
                        </div>
                        <v-text-field outlined :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'" hide-details dense
                          v-model="reFerId"></v-text-field>
                      </v-col>
                    </v-row>
                    <div class="mb-3 mt-2">
                      <div>
                        <v-checkbox hide-details v-model="checkTerm1" style="margin-bottom: 10px;" color="success">
                          <template v-slot:label>
                            <div @click="dialogTerm1 = true" style="align-items: center;display: flex;">
                              {{ $t("message.condition") }}
                              <template>
                                <a href="#" class="mr-1" @click="openPrivacyNotice">
                                  {{ $t("message.policy") }}
                                </a>
                              </template>
                            </div>
                          </template>
                        </v-checkbox>
                      </div>
                      <v-checkbox hide-details v-model="checkTerm2" color="success"
                        v-if="shopId !== 'U5bad3d6f53733785f626ceaeaad539f5' && shopId !== 'SD_1749094171700'">
                        <template v-slot:label>
                          <div style="align-items: center;display: flex;">
                            {{ $t("message.condition2") }} {{ shopname }}
                          </div>
                        </template>
                      </v-checkbox>
                    </div>
                    <v-row>
                      <v-col cols="12" v-if="!loadingbtn">
                        <v-btn block class="white--text" @click="getDataChk()" :style="{ borderRadius: isTargetShop ? '0px !important' : '' }"
                          :disabled="!validAdd || checkTerm1 == false" :color="isTargetShop ? '#000':$bgColor">
                          <div :style="{ color: isTargetShop ? '#fff' : ''}">
                            {{ sheetForm ? $t("message.regisMemberConfirm") : (shopId === $shopNameData.chubb || this.$isEventShop(shopId)) ?
                              $t("message.register") : shopId === 'SD_1749094171700' ? $t("message.registerRxTrader") :
                                $t("message.regisMember") }}
                          </div>
                        </v-btn>
                        <!-- <v-row>
                          <v-col cols="12" class="text-center mt-2">
                            <div :style="{ 'color': '#8f8c8c', 'cursor': 'pointer' }"
                              @click="dialogOTPUpdateLine = true, openOtpTelUpdateLine()">
                              {{ 'เปลี่ยนLine เบอร์เดิม' }}
                            </div>
                          </v-col>
                        </v-row> -->

                      </v-col>
                      <v-col v-if="loadingbtn" cols="12">
                        <v-btn block disabled elevation="2" loading></v-btn>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </div>
            </div>
            <div v-if="shopStatus === 'inactive'">
              <v-img :src="require('@/assets/S__27795679.jpg')" />
            </div>
          </v-col>
        </v-row>
        <!-- {{profile.userId}} -->
        <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogOTPUpdateLine" persistent>
          <v-card class="pa-5 d-flex flex-column align-center">
            <v-icon style="position:absolute; top: 10px; right: 10px;"
              @click="dialogOTPUpdateLine = false, loadingbtn = false, isProcessing = false, $router.push('/home?shopId=' + $route.query.shopId)">mdi-close</v-icon>
            <h5>เบอร์โทรศัพท์ นี้ถูกเปิดใช้งานแล้ว</h5>
            <p>กรอกเบอร์ เพื่อยืนยันการโอนย้าย ข้อมูลสมาชิก มาที่ line User Id ณ ปัจจุบัน</p>
            <v-text-field outlined :style="isTargetShop ? 'background-color: #fff; border: 1px solid #000; border-radius: 0;' : 'background-color: #EFEFEF00;'"
              v-mask="'###-###-####'"
              :rules="[rules.counterTel]" :placeholder="''" hide-details required dense
              v-model="form.tel"></v-text-field>
            <hr v-if="responseCheck && responseCheck.length" />
            <span v-if="responseCheck && responseCheck.length" class="mt-3">เลือกข้อมูลสมาชิกที่ต้องการย้าย</span>
            <div v-if="responseCheck && responseCheck.length">
              <v-list dense two-line>
                <v-list-item v-for="(value, index) in responseCheck" :key="index" @click="selectedId = getItemId(value)"
                  :style="{ cursor: 'pointer', backgroundColor: selectedId === getItemId(value) ? '#f3f8ff' : '' }">
                  <v-list-item-action>
                    <v-icon color="primary" v-if="selectedId === getItemId(value)">mdi-radiobox-marked</v-icon>
                    <v-icon v-else color="grey">mdi-radiobox-blank</v-icon>
                  </v-list-item-action>
                  <v-list-item-content>
                    <v-list-item-title class="subtitle-2">คะแนนที่คงเหลือ</v-list-item-title>
                    <v-list-item-subtitle>{{ value.currentPoint }}</v-list-item-subtitle>
                    <v-list-item-subtitle v-if="getItemId(value)">ID: {{ getItemId(value) }}</v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>

            </div>

            <!-- <p>ส่ง OTP เพื่อยืนยัน</p> -->
            <v-btn color="success" @click="confirmDeleteUnselected" :disabled="!form.tel || form.tel.replace(/-/g, '').length < 10 || !selectedId || loadingbtn">{{ $t("message.confirm") }}</v-btn>
          </v-card>
        </v-dialog>
        <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogOTPPassword" persistent>
          <v-card>
            <v-toolbar :color="$bgColor2" dark>
              <div>{{ $t("message.confirmOtp") }}</div><v-spacer></v-spacer><v-icon
                @click="dialogOTPPassword = false, loadingbtn = false">mdi-close</v-icon>
            </v-toolbar>
            <v-card-text class="text-h2 px-5" style="font-family: Kanit !important;">
              <p style="font-size: 15px;height: 33px;padding-left: 10px;" class="mb-0">{{ $t("message.waiting") }}</p>
              <div class="pa-1" style="display:flex;font-size: 15px">
                <p class="mb-0 mr-3">{{ $t("message.otpSentTo") }} </p>
                <p class="mb-0"> {{ this.form.tel }}</p>
              </div>
              <v-text-field v-model="otpPassword" class="mt-5" :label="`${this.$t('message.enterOtp')}`"
                maxlength="4"></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn color="success" @click="otpCheckAndUpdateLine">{{ $t("message.confirm") }}</v-btn>
              <!-- <v-btn
                  color="error"
                  @click="dialogOTP = false"
                >ปิด</v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog transition="dialog-bottom-transition" max-width="600" v-model="dialogOTP" persistent>
          <v-card>
            <v-toolbar :color="$bgColor2" dark>
              <div>{{ $t("message.confirmOtp") }}</div><v-spacer></v-spacer><v-icon
                @click="dialogOTP = false, loadingbtn = false">mdi-close</v-icon>
            </v-toolbar>
            <v-card-text class="text-h2 px-5" style="font-family: Kanit !important;">
              <p style="font-size: 15px;height: 33px;padding-left: 10px;" class="mb-0">{{ $t("message.waiting") }}</p>
              <div class="pa-1" style="display:flex;font-size: 15px">
                <p class="mb-0 mr-3">{{ $t("message.otpSentTo") }} </p>
                <p class="mb-0"> {{ this.form.tel }}</p>
              </div>
              <v-text-field v-model="otpPassword" class="mt-5" :label="`${this.$t('message.enterOtp')}`"
                maxlength="4"></v-text-field>
            </v-card-text>
            <v-card-actions class="justify-end">
              <v-btn color="success" @click="otpCheck">{{ $t("message.confirm") }}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <v-dialog v-model="dialogSetPin" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-overlay :value="overlay">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <div style="text-align: end;padding:10px">
              <v-btn class="mb-2" text :disabled="createPinNumber < 6" color="blue"
                @click="dialogConfirmPin = true">สร้าง</v-btn>
            </div>
            <v-list three-line subheader
              style="padding: 20px;display: flex;justify-content: center;padding-bottom: 15px;padding-top: 5px">
              <div style="text-align: center">
                <v-avatar left>
                  <v-img :src="require('@/assets/padlock.png')"></v-img>
                </v-avatar>
                <v-subheader style="font-size:16px;color: black !important;">{{ $t("message.createPin") }}</v-subheader>
              </div>
              <!-- <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Content filtering</v-list-item-title>
                  <v-list-item-subtitle>Set the content filtering level to restrict apps that can be downloaded</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>Password</v-list-item-title>
                  <v-list-item-subtitle>Require password for purchase or use password to restrict purchase</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item> -->
            </v-list>

            <div style="display: flex;justify-content: center;height: 50px;">
              <div class="mr-6 pinStyle">{{ createPinNumber[0] }}</div>
              <div class="mr-6 pinStyle">{{ createPinNumber[1] }}</div>
              <div class="mr-6 pinStyle">{{ createPinNumber[2] }}</div>
              <div class="mr-6 pinStyle">{{ createPinNumber[3] }}</div>
              <div class="mr-6 pinStyle">{{ createPinNumber[4] }}</div>
              <div class="pinStyle">{{ createPinNumber[5] }}</div>
            </div>
            <!-- <v-divider></v-divider> -->
            <p style="text-align: center;margin-top: 20px;color: rgba(0,0,0,.6);">{{ $t("message.reasonCreate") }}</p>
            <v-list three-line subheader style="margin-top: 50px;">
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col cols="4" class="text-center" style="padding-left: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('1')">
                    <span class="black--text text-h5">1</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('2')">
                    <span class="black--text text-h5">2</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('3')">
                    <span class="black--text text-h5">3</span>
                  </v-avatar>
                </v-col>
              </div>
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col cols="4" class="text-center" style="padding-left: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('4')">
                    <span class="black--text text-h5">4</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('5')">
                    <span class="black--text text-h5">5</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('6')">
                    <span class="black--text text-h5">6</span>
                  </v-avatar>
                </v-col>
              </div>
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col cols="4" class="text-center" style="padding-left: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('7')">
                    <span class="black--text text-h5">7</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('8')">
                    <span class="black--text text-h5">8</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('9')">
                    <span class="black--text text-h5">9</span>
                  </v-avatar>
                </v-col>
              </div>
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col class="text-center"><span></span></v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPin('0')">
                    <span class="black--text text-h5">0</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar class="pb-1" color="white" size="62" @click="deletePin()">
                    <span class="black--text text-h5"><v-icon size="32">mdi-backspace</v-icon></span>
                  </v-avatar>
                </v-col>
              </div>
            </v-list>
          </v-card>
        </v-dialog>
        <!-- confirm pin -->
        <v-dialog v-model="dialogConfirmPin" fullscreen hide-overlay transition="dialog-bottom-transition">
          <v-card>
            <v-overlay :value="overlayConfirmPin">
              <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
            <div style="text-align: end;padding:10px">
              <v-btn rounded class="mb-2" small @click="dialogConfirmPin = false, overlay = false"><v-icon
                  class="mr-2">mdi-arrow-left-circle</v-icon>{{ $t("message.back") }}</v-btn>
            </div>
            <v-list three-line subheader
              style="padding: 20px;display: flex;justify-content: center;padding-bottom: 15px;padding-top: 5px">
              <div style="text-align: center">
                <v-avatar left>
                  <v-img :src="require('@/assets/padlock.png')"></v-img>
                </v-avatar>
                <v-subheader style="font-size:16px;color: black !important;">{{ $t("message.confirmYourPin")
                }}</v-subheader>
              </div>
            </v-list>
            <div style="display: flex;justify-content: center;height: 50px;">
              <div class="mr-6 pinStyle">{{ conFirmPinNumber[0] }}</div>
              <div class="mr-6 pinStyle">{{ conFirmPinNumber[1] }}</div>
              <div class="mr-6 pinStyle">{{ conFirmPinNumber[2] }}</div>
              <div class="mr-6 pinStyle">{{ conFirmPinNumber[3] }}</div>
              <div class="mr-6 pinStyle">{{ conFirmPinNumber[4] }}</div>
              <div class="pinStyle">{{ conFirmPinNumber[5] }}</div>
            </div>
            <!-- <v-divider></v-divider> -->
            <!-- <p  style="text-align: center;margin-top: 20px;color: rgba(0,0,0,.6);">เพื่อความปลอดภัยในการเข้าสู่ระบบผ่านเบอร์โทรศัพท์</p> -->
            <v-list three-line subheader style="margin-top: 50px;">
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col cols="4" class="text-center" style="padding-left: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('1')">
                    <span class="black--text text-h5">1</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('2')">
                    <span class="black--text text-h5">2</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('3')">
                    <span class="black--text text-h5">3</span>
                  </v-avatar>
                </v-col>
              </div>
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col cols="4" class="text-center" style="padding-left: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('4')">
                    <span class="black--text text-h5">4</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('5')">
                    <span class="black--text text-h5">5</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('6')">
                    <span class="black--text text-h5">6</span>
                  </v-avatar>
                </v-col>
              </div>
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col cols="4" class="text-center" style="padding-left: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('7')">
                    <span class="black--text text-h5">7</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('8')">
                    <span class="black--text text-h5">8</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('9')">
                    <span class="black--text text-h5">9</span>
                  </v-avatar>
                </v-col>
              </div>
              <div style="display: flex;justify-content: space-between;" class="mb-6">
                <v-col class="text-center"><span></span></v-col>
                <v-col cols="4" class="text-center">
                  <v-avatar style="border:solid grey !important" color="white" size="62" @click="inputPinConfirm('0')">
                    <span class="black--text text-h5">0</span>
                  </v-avatar>
                </v-col>
                <v-col cols="4" class="text-center" style="padding-right: 60px">
                  <v-avatar class="pb-1" color="white" size="62" @click="deletePinConfirm()">
                    <span class="black--text text-h5"><v-icon size="32">mdi-backspace</v-icon></span>
                  </v-avatar>
                </v-col>
              </div>
            </v-list>
          </v-card>
        </v-dialog>
      </v-container>
    </v-main>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from 'axios'
import Swal from 'sweetalert2'
import moment from 'moment-timezone'
// import router from '../../router'

export default {
  name: 'RegisterMember',
  data () {
    return {
      menu1: false,
      checkBoxValue: null,
      checkTerm1: true,
      checkTerm2: true,
      validAdd: true,
      loadingbtn: false,
      showRegis: false,
      friendGate: false,
      friendChecking: false,
      activePicker: null,
      shopStatus: null,
      reFerId: null,
      pictureUrlPreview: null,
      filesAdd: null,
      customFeild: [],
      choiceGender: [
        { text: 'ชาย', value: 'male' },
        { text: 'หญิง', value: 'female' },
        { text: 'ไม่ระบุ', value: 'ไม่ระบุ' }
      ],
      choiceGenderEng: [
        { text: 'male', value: 'male' },
        { text: 'female', value: 'female' },
        { text: 'N/A', value: 'ไม่ระบุ' }
      ],
      choiceGenderKke: [
        { text: 'ชาย', value: 'male' },
        { text: 'หญิง', value: 'female' }
      ],
      choiceGenderEngKke: [
        { text: 'male', value: 'male' },
        { text: 'female', value: 'female' }
      ],
      form: {
        tel: '',
        bdDate: '',
        nameCustomer: ''
      },
      profile: {
        userId: '',
        displayName: '',
        pictureUrl: '',
        statusMessage: ''
      },
      thai: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-TH.png?alt=media&token=e4bd7ffa-aed9-47e3-9240-4dcb9d8d284e',
      eng: 'https://firebasestorage.googleapis.com/v0/b/betask-linked/o/picture-web%2Fflag-USA1.png?alt=media&token=a83dd820-f576-457a-8d08-1009cea9d70b',
      profile_dev: {
        displayName: 'Tommm',
        pictureUrl:
          'https://sprofile.line-scdn.net/0hZRsyZnrmBX1eAC76d817Ai5QBhd9cVxvc2UYSW1QWk4xORZ4d24dHmMAC0ViZRJ-czQZTz4GXEVSE3IbQFb5SVkwW0pnMkQsc29Jnw',
        statusMessage: 'บังไค (Smug)',
        userId: 'Uce4206cc8a8aecce95875fa90b88347b'
      },
      rules: {
        numberRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999) ||
          `${this.$t('message.fillNum')}`,
        counterTel: (value) => value.length > 11 || 'Max 10 characters',
        IDcardRules: (value) =>
          (!isNaN(parseFloat(value)) && value >= 0 && value <= 9999999999999) ||
          `${this.$t('message.fillNum')}`,
        required: (value) => !!value || 'กรุณากรอก.',
        counterIDcard: (value) => value.length <= 13 || 'Max 13 characters',
        contract: (value) => {
          if (!value) return true // หรือ false ถ้าต้องการบังคับกรอก
          const pattern = /^[A-Z]{2}\d{1,3}-\d{4}$/

          return pattern.test(value) || 'รูปแบบต้องเป็น ตัวอักษร 2 ตัวใหญ่ - ตัวเลข 4 ตัว เช่น AB-1234'
        },
        empId: (value) => {
          const pattern = /^[a-zA-Z]{2}[0-9]{5}$/
          return pattern.test(value) || 'A-Z 2 + 5 digits EX. (AA12345).'
        },
        email: (value) => {
          const pattern =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      lineUserIds: '',
      liffUserIds: '',
      statusMember: '',
      memberId: '',
      loyaltyId: '',
      belinkId: '',
      statusLoyalty: '',
      statusBelink: '',
      lineUserIdLoyalty: '',
      lineUserIdLinked: '',
      dataloyalty: '',
      gender: null,
      result: null,
      shopname: null,
      shopInfo: null,
      basicId: null,
      fromflex: null,
      source: null,
      valueCustomFeild: [],
      radioGroup: null,
      tel: null,
      profileUrl: null,
      dialogSetPin: false,
      dialogConfirmPin: false,
      dialogOTP: false,
      otpPassword: '',
      createPinNumber: '',
      conFirmPinNumber: '',
      overlay: false,
      overlayConfirmPin: false,
      remark: null,
      theme: null,
      email: null,
      emailCheckStatus: false,
      hiddenSystemFields: [], // ช่องเดิมที่หลังบ้านสั่งซ่อน (CustomField ชนิด hideSystemField)
      importData: null,
      odooId: null,
      fontColorLMG: '#000000',
      dialogOTPUpdateLine: false,
      telUpdateLine: '',
      dialogOTPPassword: false,
      responseCheck: null,
      selectedId: null,
      isProcessing: false,
      otpVerified: false
    }
  },
  watch: {
    menu1 (val) {
      val && setTimeout(() => (this.$refs.picker1.activePicker = 'YEAR'))
    },
    '$route.query.importData': {
      handler (newVal, oldVal) {
        // This function will be called whenever the importData query parameter changes
        if (newVal) {
          this.importData = this.$route.query.importData
          if (this.importData) {
            this.info = JSON.parse(sessionStorage.getItem('info'))
            if (this.info) {
              this.form.nameCustomer = this.info.nameCustomer
              this.gender = this.info.gender

              if (this.info.birthDay) {
                const daysBetween = this.info.birthDay // ลบ 1 เนื่องจาก Excel นับวันที่เริ่มต้นที่ 1900-01-01
                const millisecondsPerDay = 24 * 60 * 60 * 1000 // จำนวนมิลลิวินาทีในหนึ่งวัน

                const excelStartDate = new Date(1899, 11, 30) // วันที่เริ่มต้นของ Excel (1900-01-01 ใน Excel ถูกตัดสินใจว่าไม่ได้มี)
                const offsetMilliseconds = daysBetween * millisecondsPerDay

                const jsDate = new Date(excelStartDate.getTime() + offsetMilliseconds)
                const year = jsDate.getFullYear()
                const month = String(jsDate.getMonth() + 1).padStart(2, '0')
                const day = String(jsDate.getDate()).padStart(2, '0')

                const formattedDate = `${year}-${month}-${day}`

                this.form.bdDate = formattedDate
              } else {
                this.form.bdDate = null
              }
              this.remark = this.info.remark
              this.form.email = this.info.email
            }
          }
          // Your logic here
        }
      },
      immediate: true // Run the handler immediately on component mount
    },
    '$route.query.tel': {
      handler (newVal, oldVal) {
        if (newVal) {
          this.form.tel = newVal.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
        }
      },
      immediate: true // Run the handler immediately on component mount
    },
    'form.tel': function (newVal, oldVal) {
      try {
        if (this.isProcessing) {
          return
        }
        const newDigits = newVal ? newVal.replace(/\D/g, '') : ''
        const oldDigits = oldVal ? oldVal.replace(/\D/g, '') : ''
        // When phone reaches 10 digits (complete) and it was not complete before
        if (newDigits.length === 10 && oldDigits.length !== 10) {
          // debounce a tick to allow v-model to settle
          this.$nextTick(() => {
            if (this.dialogOTPUpdateLine) {
              if (typeof this.openOtpTelUpdateLine === 'function') this.openOtpTelUpdateLine()
            }
          })
        }
      } catch (e) {
        console.error('watch form.tel error', e)
      }
    }
  },
  computed: {
    isTargetShop () {
      return this.$isTargetShop()
    },
    isTargetShopId () {
      // id ที่ใช้ใน $isTargetShop
      return this.$isTargetShop()
    },
    computedStyle () {
      return this.isTargetShop ? this.fontColorLMG : this.$textcolor
    },
    // ร้านอีเวนต์ที่ทำหน้าสมัครตามชีตลูกค้า: โลโก้+ชื่อร้านบนหัว, ชื่อ → อีเมล → เบอร์, ปุ่ม "ยืนยันสมัครสมาชิก"
    sheetForm () {
      return this.$eventShopOption(this.$route.query.shopId, 'sheetRegisterForm')
    },
    // พื้นหลังหัวหน้าสมัครตามชีตลูกค้า (เฉพาะร้านอีเวนต์ที่ตั้ง registerCover)
    registerCover () {
      return this.sheetForm ? this.$eventShopValue(this.$route.query.shopId, 'registerCover') : undefined
    },
    requireFriendOa () {
      return this.$eventShopValue(this.$route.query.shopId, 'requireFriend')
    }

  },
  beforeDestroy () {
    document.removeEventListener('visibilitychange', this.onVisibleCheckFriend)
  },
  // eslint-disable-next-line space-before-function-paren
  async mounted() {
    this.reFerId = this.$route.query.reFerId
    this.source = this.$route.query.source
    this.tel = this.$route.query.tel
    this.odooId = this.$route.query.odooId
    this.importData = this.$route.query.importData
    this.theme = this.GET_THEME()
    this.shopInfo = this.GET_SHOPINFO()
    await this.getOnlyShop()
    await this.getCustomFeild()
    // let a = await this.callBeTaskAPI('get', `/member-gender/Uc520945108b983b6e739ed0a8cd8dae4`)
    // console.log('a', a)
    this.profile = this.getLiffProfile()
    if (this.requireFriendOa) {
      await this.checkFriend()
      document.addEventListener('visibilitychange', this.onVisibleCheckFriend)
    }
    // this.validate('ADD')
    // await this.validate('ADD')
    if (this.tel) {
      this.form.tel = this.tel.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3')
    }
    if (this.importData) {
      this.info = JSON.parse(sessionStorage.getItem('info'))
      if (this.info) {
        this.form.nameCustomer = this.info.nameCustomer
        this.gender = this.info.gender

        if (this.info.birthDay) {
          const daysBetween = this.info.birthDay // ลบ 1 เนื่องจาก Excel นับวันที่เริ่มต้นที่ 1900-01-01
          const millisecondsPerDay = 24 * 60 * 60 * 1000 // จำนวนมิลลิวินาทีในหนึ่งวัน

          const excelStartDate = new Date(1899, 11, 30) // วันที่เริ่มต้นของ Excel (1900-01-01 ใน Excel ถูกตัดสินใจว่าไม่ได้มี)
          const offsetMilliseconds = daysBetween * millisecondsPerDay

          const jsDate = new Date(excelStartDate.getTime() + offsetMilliseconds)
          const year = jsDate.getFullYear()
          const month = String(jsDate.getMonth() + 1).padStart(2, '0')
          const day = String(jsDate.getDate()).padStart(2, '0')

          const formattedDate = `${year}-${month}-${day}`

          this.form.bdDate = formattedDate
        } else {
          this.form.bdDate = null
        }
        this.remark = this.info.remark
        this.form.email = this.info.email
      }
    }
    if (
      this.$route.query.type === 'loyaltyLinked' ||
      this.$route.query.type === 'VLinked'
    ) {
      await axios
        .get(
          this.DNS_IP +
          '/member/get?shopId=' +
          this.$route.query.shopId +
          '&liffUserId=' +
          this.profile.userId
        )

        .then(async (result) => {
          if (result.data.status === undefined) {
            this.loyaltyId = result.data[0].memberId
            this.lineUserIdLoyalty = result.data[0].lineUserId || ''
            this.dataloyalty = result.data[0]
            this.statusLoyalty = true
          } else {
            this.statusLoyalty = false
          }
        })
      await axios
        .get(
          'https://api-belinked.betaskthai.tech' +
          '/member/get?shopId=' +
          this.$route.query.shopId +
          '&liffUserId=' +
          this.profile.userId
        )
        .then(async (result) => {
          if (result.data.status === undefined) {
            this.belinkId = result.data[0].memberId
            this.lineUserIdLinked = result.data[0].lineUserId || ''
            this.statusBelink = true
          } else {
            this.statusBelink = false
          }
        })
      if (this.statusLoyalty && !this.statusBelink) {
        this.onSubmitBelink(this.dataloyalty)
      } else if (this.statusLoyalty && this.statusBelink) {
        if (this.lineUserIdLoyalty === '' && this.lineUserIdLinked !== '') {
          await this.onUpdate(this.loyaltyId)
        } else if (
          this.lineUserIdLoyalty !== '' &&
          this.lineUserIdLinked === ''
        ) {
          await this.onUpdateBelink(this.belinkId)
        } else if (
          this.lineUserIdLoyalty === '' &&
          this.lineUserIdLinked === ''
        ) {
          // alert(this.lineUserIdLoyalty)
          // alert(this.lineUserIdLinked)
          if (this.$liff.isInClient()) {
            this.$liff
              .sendMessages([
                {
                  type: 'text',
                  text:
                    'คุณได้เปิดการแจ้งเตือนและบัตรสะสมแต้มไปแล้ว หมายเลขสมาชิกของคุณคือ ' +
                    this.loyaltyId +
                    '-' +
                    this.belinkId
                }
              ])
              .then(() => {
                window.location = this.getHomeUrl()
              })
              .catch((err) => {
                console.error('error', err)
              })
          } else {
            window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken
            }&nonce=${this.loyaltyId + '_' + this.belinkId}-${this.profile.userId
            }-loyaltyLinkedUpdate`
          }
        } else if ( /// เชค case พี่ชินเพิ่ม เชค token ว่ามีสถานะอะไร
          this.lineUserIdLoyalty !== '' &&
          this.lineUserIdLinked !== ''
        ) {
          if (this.$route.query.token) {
            await axios
              .get(
                this.DNS_IP +
                '/qrcode/get?token=' +
                this.$route.query.token + '&shopId=' + this.$route.query.shopId
              )
              .then(async (result) => {
                if (result.data.length > 0) {
                  if (result.data[0].status === 'waiting') {
                    if (this.$route.query.type === 'VLinked') {
                      if ((result.data[0].productExchangeRateId === 165 || 218) && result.data[0].refId !== '') {
                        await axios.get(this.DNS_IP + '/qrcode/get?refId=' + result.data[0].refId + '&shopId=' + result.data[0].shopId +
                          '&productExchangeRateId=165&status=used'
                        ).then((a) => {
                          if (a.data.status === false) {
                            this.$router.push('/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token)
                          } else {
                            this.$liff
                              .sendMessages([
                                {
                                  type: 'text',
                                  text: 'คะแนนนี้ได้รับไปเเล้ว'
                                }
                              ])
                              .then(() => {
                                this.$liff.closeWindow()
                              })
                              .catch((err) => {
                                console.error('error', err)
                              })
                          }
                        })
                      } else if (result.data[0].productExchangeRateId !== 165) {
                        this.$router.push('/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token)
                      } else {
                        Swal.fire({
                          title: `${this.$t('message.fail')}`,
                          text: 'ไม่เลขตัวถังในระบบ กรุณาติดต่อเจ้าหน้าที่',
                          icon: 'error',
                          confirmButtonText: 'รับทราบ',
                          confirmButtonColor: '#3085d6'
                        })
                          .then((confirm) => {
                            if (confirm.isConfirmed) {
                              window.location = this.getHomeUrl()
                            } else {
                              window.location = this.getHomeUrl()
                            }
                          })
                          .catch((err) => {
                            console.error('error', err)
                            window.location = this.getHomeUrl()
                          })
                      }
                    } else {
                      this.$router.push('/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token)
                    }
                  } else {
                    if (this.$liff.isInClient()) {
                      this.$liff
                        .sendMessages([
                          {
                            type: 'text',
                            text: 'คะแนนนี้ได้รับไปเเล้ว'
                          }
                        ])
                        .then(() => {
                          this.$liff.closeWindow()
                        })
                        .catch((err) => {
                          console.error('error', err)
                        })
                    } else {
                      Swal.fire({
                        title: `${this.$t('message.fail')}`,
                        text: `${this.$t('message.pointBeenReceived')}`,
                        icon: 'error',
                        confirmButtonText: `${this.$t('message.ok')}`,
                        confirmButtonColor: '#3085d6'
                      })
                        .then((confirm) => {
                          if (confirm.isConfirmed) {
                            window.location = this.getHomeUrl()
                          } else {
                            window.location = this.getHomeUrl()
                          }
                        })
                        .catch((err) => {
                          console.error('error', err)
                          window.location = this.getHomeUrl()
                        })
                    }
                  }
                } else {
                  Swal.fire({
                    title: `${this.$t('message.fail')}`,
                    text: `${this.$t('message.message')}`,
                    icon: 'error',
                    confirmButtonText: `${this.$t('message.ok')}`,
                    confirmButtonColor: '#3085d6'
                  })
                    .then((confirm) => {
                      if (confirm.isConfirmed) {
                        window.location = this.getHomeUrl()
                      } else {
                        window.location = this.getHomeUrl()
                      }
                    })
                    .catch((err) => {
                      console.error('error', err)
                      window.location = this.getHomeUrl()
                    })
                }
              })
          } else {
            Swal.fire({
              title: 'success',
              text: `${this.$t('message.thisAlready')}`,
              icon: 'error',
              confirmButtonText: `${this.$t('message.ok')}`,
              confirmButtonColor: '#3085d6'
            })
              .then((confirm) => {
                if (confirm.isConfirmed) {
                  window.location = this.getHomeUrl()
                } else {
                  window.location = this.getHomeUrl()
                }
              })
              .catch((err) => {
                console.error('error', err)
                window.location = this.getHomeUrl()
              })
            this.$liff
              .sendMessages([
                {
                  type: 'text',
                  text: 'คุณได้ทำรายการนี้ไปแล้วครับ'
                }
              ])
              .then(() => {
                // this.$liff.closeWindow()
                window.location = this.getHomeUrl()
              })
              .catch((err) => {
                console.error('error', err)
              })
          }
        }
      }
    } else {
      await axios
        .get(
          this.DNS_IP +
          '/member/get?shopId=' +
          this.$route.query.shopId +
          `${this.tel ? '&tel=' : '&liffUserId='}` +
          `${this.tel ? this.tel : this.profile.userId}`
        )
        .then(async (result) => {
          if (typeof result.data.status === 'undefined') {
            this.lineUserIds = result.data[0].lineUserId || ''
            this.liffUserIds = result.data[0].liffUserId || ''
            this.memberId = result.data[0].memberId
          } else {
            this.statusMember = result.data.status
          }
          if (this.statusMember === false) {
          } else if (this.lineUserIds === '' && this.liffUserIds !== '') {
            await this.onUpdate(this.memberId)
          } else if (this.lineUserIds !== '' && this.liffUserIds !== '') {
            if (this.$liff.isInClient()) {
              this.$liff
                .sendMessages([
                  {
                    type: 'text',
                    text: 'คุณได้ทำรายการนี้ไปแล้ว'
                  }
                ])
                .then(() => {
                  let swalOptions = {
                    title: `${this.$t('message.alreadyRegis')}`,
                    text: this.$isTargetShop() ? '' : 'กดปุ่ม "เปลี่ยนไลน์เบอร์เดิม" หากต้องการโอนย้ายข้อมูล',
                    icon: 'warning',
                    confirmButtonText: `${this.$t('message.ok')}`,
                    confirmButtonColor: '#3085d6',
                    showCancelButton: !this.$isTargetShop(),
                    cancelButtonText: 'เปลี่ยนไลน์เบอร์เดิม',
                    cancelButtonColor: '#ffa300',
                    allowOutsideClick: false,
                    reverseButtons: true
                  }

                  if (this.$isTargetShop()) {
                    swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                    swalOptions.imageWidth = 100
                    swalOptions.imageHeight = 100
                  } else {
                    swalOptions.icon = 'success'
                  }

                  Swal.fire(swalOptions)
                    .then(async (confirm) => {
                      if (confirm.isDenied) {
                        await this.openOtpTelUpdateLine()
                        return
                      }
                      if (confirm.isConfirmed) {
                        if (this.$route.query.shopId === 'SD_1749094171700') {
                          this.$router.push('/StampRXTradex')
                          window.location = '/StampRXTradex'
                          return
                        }
                        window.location = this.getHomeUrl()
                      } else {
                        if (this.$route.query.shopId === 'SD_1749094171700') {
                          this.$router.push('/StampRXTradex')
                          return
                        }
                        window.location = this.getHomeUrl()
                      }
                    })
                    .catch((err) => {
                      console.error('error', err)
                      if (this.$route.query.shopId === 'SD_1749094171700') {
                        this.$router.push('/StampRXTradex')
                        return
                      }
                      window.location = this.getHomeUrl()
                    })
                  // window.location = this.getHomeUrl()
                })
                .catch((err) => {
                  console.error('error', err)
                  alert('ผิดพลาด โหลดข้อมูลไม่สำเสร็จ')
                })
            } else {
              let swalOptions = {
                title: `${this.$t('message.alreadyRegis')}`,
                text: this.isTargetShop ? '' : 'กดปุ่ม "เปลี่ยนไลน์เบอร์เดิม" หากต้องการโอนย้ายข้อมูล',
                icon: 'warning',
                confirmButtonText: `${this.$t('message.ok')}`,
                confirmButtonColor: '#3085d6',
                showCancelButton: !this.isTargetShop,
                cancelButtonText: 'เปลี่ยนไลน์เบอร์เดิม',
                cancelButtonColor: '#ffa300',
                allowOutsideClick: false,
                reverseButtons: true
              }

              if (this.$isTargetShop()) {
                swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                swalOptions.imageWidth = 100
                swalOptions.imageHeight = 100
              }

              Swal.fire(swalOptions)
                .then(async (confirm) => {
                  if (confirm.isDenied) {
                    await this.openOtpTelUpdateLine()
                    return
                  }
                  if (confirm.isConfirmed) {
                    if (this.$route.query.shopId === 'SD_1749094171700') {
                      this.$router.push('/StampRXTradex')
                      return
                    }
                    window.location = this.getHomeUrl()
                  } else {
                    if (this.$route.query.shopId === 'SD_1749094171700') {
                      this.$router.push('/StampRXTradex')
                      return
                    }
                    window.location = this.getHomeUrl()
                  }
                })
                .catch((err) => {
                  console.error('error', err)
                  if (this.$route.query.shopId === 'SD_1749094171700') {
                    this.$router.push('/StampRXTradex')
                    return
                  }
                  window.location = this.getHomeUrl()
                })
            }
          }
        })
    }
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapActions('lineStore', ['setProfile']),
    ...mapActions('memberStore', ['getMemberProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),
    ...mapGetters('shopStore', ['GET_SHOPID', 'GET_THEME', 'GET_SHOPINFO']),
    checkShop () {
      let status = this.GET_SHOPID.includes(this.$isTargetShop)
      return status
    },
    getHomeUrl () {
      // ถ้าเป็น LMG shop ให้ไป /C แทน /home
      // เพิ่ม fromRegister=already เพื่อบอก Home.vue ว่าไม่ต้อง redirect กลับ
      if (this.$isTargetShop()) {
        return '/C?shopId=' + this.$route.query.shopId + '&fromRegister=already'
      }
      return '/home?shopId=' + this.$route.query.shopId + '&fromRegister=already'
    },
    rePick (i) {
      this.$delete(this.customFeild[i], 'ChoseAnotherAnswer')
    },
    checkAnother (selectedItem, i) {
      if (selectedItem === 'อื่น ๆ' || selectedItem === 'other') {
        this.customFeild[i].ChoseAnotherAnswer = 'True'
        this.valueCustomFeild[i].value = ''
      }
    },
    checkAnotherAnswer (item) {
      let dataChoice = JSON.parse(item)
      this.$i18n.locale === 'th' ? dataChoice.push('อื่น ๆ') : dataChoice.push('other')
      return dataChoice
    },
    changlangue () {
      this.$i18n.locale = this.$i18n.locale === 'th' ? 'en' : 'th'
    },
    warningPutData () {
      Swal.fire({
        title: 'ผิดพลาด',
        text: 'กรุณากรอกข้อมูลให้ครบถ้วน และ คลิกยอมรับ นโยบายความเป็นส่วนตัว',
        icon: 'error',
        confirmButtonText: 'รับทราบ',
        confirmButtonColor: '#3085d6'
      })
    },
    pushValueCheckbox (i, item2) {
      // ถ้าใน this.valueCustomFeild[i] key value จะต้องมาเช็คตามเงื่อนไขด้านล่าง
      if (this.valueCustomFeild[i].value) {
        //  split เป็น array เเละเอาไป find หา value ที่ซ้ำ ถ้าเจอซ้ำ
        let a = this.valueCustomFeild[i].value.split(',')
        if (a.find(element => element === item2)) { // ถ้่าเจอซ้ำ
          let findItem = this.valueCustomFeild[i].value.split(',')
          if (findItem.length === 1) { // ถ้า lenght เป็น 1 ให้ลบ key value เลยเพื่อจได้ไม่เจอ key ชื่อ value และจะ ได้เข้าif บนสุดอีกครั้ง
            delete this.valueCustomFeild[i].value
          } else { // ถ้า lenght มากกว่า 1 ให้ filter ค่าที่ซ้ำออกและ join array ด้วย ',' และเพิ่มเข้าไปใน this.valueCustomFeild[i].value
            this.valueCustomFeild[i].value = findItem.filter(item => item !== item2).join(',')
          }
        } else { // ถ้่าไม่เจอซ้ำ
          // เพิ่มต่อ string ที่มี ',' ข้างหน้า value ====> value: "ไปไหน, ไปเที่ยว"
          this.valueCustomFeild[i].value = this.valueCustomFeild[i].value + ',' + item2
        }
      } else {
        // ถ้าใน this.valueCustomFeild[i] ไม่มี key value เพิ่ม text value ====> value: "ไปไหน"
        this.valueCustomFeild[i].value = item2
      }
    },
    async checkFriend () {
      if (!this.requireFriendOa) return true
      this.friendChecking = true
      try {
        const friendship = await this.$liff.getFriendship()
        this.friendGate = !friendship.friendFlag
      } catch (error) {
        // เช็กไม่ได้ (LIFF ยังไม่ผูก OA) ไม่ล็อกทั้งร้าน ให้สมัครต่อได้
        console.error('getFriendship', error)
        this.friendGate = false
      }
      this.friendChecking = false
      return !this.friendGate
    },
    onVisibleCheckFriend () {
      if (document.visibilityState === 'visible' && this.friendGate) this.checkFriend()
    },
    openAddFriend () {
      const url = 'https://line.me/R/ti/p/' + encodeURIComponent(this.requireFriendOa)
      if (this.$liff.isInClient && this.$liff.isInClient()) {
        this.$liff.openWindow({ url, external: false })
      } else {
        window.location.href = url
      }
    },
    openPrivacyNotice () {
      window.open(window.location.origin + '/PrivacyNotice', '_blank').focus()
    },
    test (data) {
    },
    async getOnlyShop () {
      const result = await this.callBeTaskAPI(
        'get',
        `/only_shop/get?shopId=${this.$route.query.shopId}`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.shopname = result[0].name
          this.shopStatus = result[0].shopStatus
          this.shopInfo = result[0]
          this.showRegis = true
        }
      }
    },
    save1 (date) {
      this.$refs.menu1.save(date)
    },
    validate (Action) {
      switch (Action) {
        case 'ADD':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_add.validate()
          })
          break
        case 'UPDATE':
          this.$nextTick(() => {
            let self = this
            self.$refs.form_update.validate()
          })
          break

        default:
          break
      }
    },
    selectGender (a) {
      this.gender = a
    },
    // testvalueCustomFeild () {
    //   console.log(this.valueCustomFeild)
    // },
    async getDataChk () {
      // กันสมัครข้ามด่านเพิ่มเพื่อน (เช็กซ้ำตอนกดสมัคร)
      if (this.requireFriendOa && !(await this.checkFriend())) return
      const valid = this.$refs.form_add.validate()
      if (valid === true) {
        this.loadingbtn = true

        if (
          this.$route.query.type === 'loyaltyLinked' ||
          this.$route.query.type === 'VLinked'
        ) {
          if (!this.statusLoyalty && !this.statusBelink) {
            await this.onSubmit()
          } else if (!this.statusLoyalty && this.statusBelink) {
            if (this.profile.userId) {
              await this.onSubmit()
            } else {
              Swal('ผิดพลาด!', 'กรุณาทำรายการใหม่ (profile.userId ไม่มีค่า)', 'error')
              console.error('Branch: profile.userId ไม่มีค่า')
            }
          }
        } else if (this.$eventShopOption(this.$route.query.shopId, 'skipOtp')) {
          // ร้านอีเวนต์: ลงทะเบียนหน้างานด้วยชื่อ อีเมล เบอร์ ไม่ยืนยัน OTP (ไม่ส่ง SMS ทีละหลายร้อยข้อความ)
          await this.onSubmit()
        } else {
          if (
            this.theme.otpConfirm === 'True' ||
            this.$route.query.shopId !== this.$shopNameData.chubb ||
            this.$route.query.shopId === 'Ub067d158c52aaaec79b67cfc997fda79'
          ) {
            await this.onSubmitKKEandLin()
          } else {
            await this.onSubmit()
          }
        }
      }
    },
    chooseImage () {
      this.$refs.fileInput.click()
    },
    onSelectFile () {
      const input = this.$refs.fileInput
      this.filesAdd = input.files
      if (this.filesAdd) {
        this.pictureUrlPreview = URL.createObjectURL(this.filesAdd[0])
      } else {
        this.pictureUrlPreview = ''
      }
      this.$forceUpdate()
    },

    async openOtpTelUpdateLine () {
      if (this.isTargetShop) {
        Swal.fire({
          title: 'ไม่สามารถใช้งานได้',
          text: 'ขออภัย ฟีเจอร์นี้ไม่สามารถใช้งานได้สำหรับร้านนี้',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#3085d6'
        })
        this.loadingbtn = false
        return
      }

      // Set flag to prevent watch from triggering
      this.isProcessing = true

      // เปิด dialog ให้ผู้ใช้กรอกเบอร์โทร
      this.dialogOTPUpdateLine = true

      // ถ้ามีเบอร์โทรอยู่แล้ว ให้เรียก API เพื่อค้นหาข้อมูลสมาชิก
      const tel = this.form.tel ? this.form.tel.split('-').join('').trim() : ''
      if (!tel) {
        return
      }

      try {
        await axios.get(
          this.DNS_IP + '/member/getbyphone',
          {
            params: {
              tel: tel,
              shopId: this.$route.query.shopId
            }
          }
        ).then((response) => {
          if (
            response.data
          ) {
            this.responseCheck = response.data
            // default select all items
            if (Array.isArray(this.responseCheck) && this.responseCheck.length) {
              this.selectedId = this.getItemId(this.responseCheck[0]) || null
            }
            this.loadingbtn = false
            this.isProcessing = false
          }
        }).catch((error) => {
          console.error('There was an error!', error)
          return error.response
        })
        console.error('this.responseCheck', this.responseCheck)
      } catch (error) {
        console.error('Error setting loadingbtn:', error)
      }
    },
    getItemId (item) {
      return item.memberId || null
    },
    async confirmDeleteUnselected () {
      if (this.loadingbtn) return
      if (!this.form.tel || this.form.tel.length < 10) {
        Swal.fire({
          title: 'กรุณากรอกเบอร์โทรศัพท์',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#3085d6'
        })
        return
      }

      if (!this.selectedId) {
        Swal.fire({
          title: 'กรุณาเลือกข้อมูลที่ต้องการย้าย',
          icon: 'warning',
          confirmButtonText: 'ตกลง',
          confirmButtonColor: '#3085d6'
        })
        return
      }

      // const allIds = (this.responseCheck || []).map(v => this.getItemId(v)).filter(Boolean)
      // const unselected = allIds.filter(memberId => memberId !== this.selectedId)

      this.loadingbtn = true
      if (this.otpVerified) {
        // ผ่าน OTP รอบแรก (registration) มาแล้ว → ข้าม postOTP ไปเรียก update ได้เลย
        this.dialogOTPUpdateLine = false
        await this.executeLineUpdate()
      } else {
        // Send OTP first
        try {
          await this.postOTP()
        } catch (error) {
          console.error('Failed to send OTP:', error)
          this.loadingbtn = false
        }
      }
    },
    async deleteUnselected (unselectedIds) {
      try {
        this.loadingbtn = true
        const results = []
        for (const id of unselectedIds) {
          try {
            const res = await axios.post(this.DNS_IP + `/memberCard/deleteItem/${id}`, { LAST_USER: this.profile.userId })
            results.push({ id, ok: true, res })
          } catch (err) {
            console.error('delete error', id, err)
            results.push({ id, ok: false, err })
          }
        }
        this.loadingbtn = false
        // refresh list
        // this.dialogOTPPassword = false
      } catch (error) {
        this.loadingbtn = false
        console.error(error)
        Swal.fire({ title: this.$t('message.fail') || 'Failed', text: error.message || error, icon: 'error', confirmButtonText: this.$t('message.ok') || 'OK' })
      }
    },
    async onSubmit () {
      if (this.$route.query.token && !this.$route.query.memberId) {
        alert('atom')

        var idMember = moment().valueOf()
        let params = {}

        if (this.$route.query.type === 'VLinked') {
          params = {
            name: this.profile.displayName.replace(/'/g, "\\'"),
            picture: this.profile.pictureUrl,
            tel: this.$route.query.shopId === this.$shopNameData.chubb
              ? this.form.tel.toUpperCase()
              : this.form.tel.split('-').join('').trim(),
            gender: this.gender,
            birthDay: this.form.bdDate,
            nameCustomer: this.form.nameCustomer,
            liffUserId: this.profile.userId,
            memberId: idMember,
            shopId: this.$route.query.shopId,
            lineUserIdVLinked: this.$route.query.lineUserIdVLinked,
            CONDITION_TERM1: this.checkTerm1,
            CONDITION_TERM2: this.checkTerm2,
            CREATE_USER: this.profile.userId,
            LAST_USER: this.profile.userId
          }
        } else {
          params = {
            name: this.profile.displayName.replace(/'/g, "\\'"),
            picture: this.profile.pictureUrl,
            gender: this.gender,
            tel: this.$route.query.shopId === this.$shopNameData.chubb
              ? this.form.tel.toUpperCase()
              : this.form.tel.split('-').join('').trim(),
            barcodeNum: this.$route.query.shopId === this.$shopNameData.chubb
              ? this.form.tel.toUpperCase()
              : this.form.tel.split('-').join('').trim(),
            birthDay: this.form.bdDate,
            nameCustomer: this.form.nameCustomer,
            liffUserId: this.profile.userId,
            memberId: this.$route.query.memberId ? this.$route.query.memberId : idMember,
            shopId: this.$route.query.shopId,
            CONDITION_TERM1: this.checkTerm1,
            CONDITION_TERM2: this.checkTerm2,
            CREATE_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId,
            LAST_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId
          }
        }
        // const paramsCollect = {
        //   token: this.$route.query.token
        // }

        if (this.reFerId && this.reFerId.length > 6) {
          params.reFerId = this.reFerId
        }
        if (this.customFeild.length > 0) {
          let JSONvalueCustomFeild = JSON.stringify(this.valueCustomFeild)
          params.regisCustomFeild = JSONvalueCustomFeild
        }
        let result = await this.callBeTaskAPI('post', `/member/addRegis`, params)
        if (result.status) {
          try {
            if (result.message === 'tel is duplicate') {
              await this.openOtpTelUpdateLine()
              return
            }
            // await this.callBeTaskAPI('post', `/memberCard/edit`, paramsCollect)
            if (this.$route.query.type === 'VLinked') {
              if (this.$liff.isInClient()) {
                this.$liff
                  .sendMessages([
                    {
                      type: 'text',
                      text:
                        'ย้ายlineใหม่ ' +
                        idMember
                    }
                  ])
                  .then(() => {
                    if (this.$route.query.redirectUrl) {
                      window.location = this.$route.query.redirectUrl
                    } else {
                      window.location = this.getHomeUrl()
                    }
                  })
                  .catch((err) => {
                    console.error('error', err)
                  })
              } else {
                if (this.$route.query.redirectUrl) {
                  window.location = this.$route.query.redirectUrl
                } else {
                  window.location = this.getHomeUrl()
                }
                // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Loyalty`
              }
            } else {
              if (this.$liff.isInClient()) {
                // alert('isInClient')
                this.$liff
                  .sendMessages([
                    {
                      type: 'text',
                      text:
                        'เปิดใช้งานบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                        idMember
                    }
                  ])
                  .then(() => {
                    // /collect?shopId=Ucb91b5fb61ff0c01e6d7d4c5f7962c57&token=d33d324918689bf4d6a7eb45eaaf05c4
                    if (this.$route.query.redirectUrl) {
                      window.location = this.$route.query.redirectUrl
                    } else {
                      window.location = '/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token
                    }
                  })
                  .catch((err) => {
                    console.error('error', err)
                    window.location = '/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token
                  })
              } else {
                if (this.$route.query.redirectUrl) {
                  window.location = this.$route.query.redirectUrl
                } else {
                  window.location = '/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token
                }
                // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Loyalty`
              }
            }
          } catch (error) {
            this.loadingbtn = false
            this.isProcessing = false
            console.error('onSubmit token error:', error)
            window.location = this.getHomeUrl()
          }
        } else {
          this.loadingbtn = false
          this.isProcessing = false
          if (result.message === 'tel is duplicate') {
            // Swal.fire({
            //   title: 'เบอร์โทรศัพท์ นี้ถูกเปิดใช้งานแล้ว',
            //   icon: 'error',
            //   showCancelButton: false,
            //   confirmButtonColor: '#3085d6',
            //   cancelButtonColor: '#b3b1ab',
            //   confirmButtonText: 'ตกลง'
            // }).then((confirm) => {
            //   if (confirm.isConfirmed) {
            //     this.form.tel = ''
            //   }
            // })
            await this.openOtpTelUpdateLine()
          } else {
            this.loadingbtn = false
            this.isProcessing = false
            Swal.fire({
              title: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
              icon: 'error',
              showCancelButton: false,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#b3b1ab',
              confirmButtonText: 'ตกลง'
            }).then((confirm) => {
              if (confirm.isConfirmed) {
                location.reload()
              }
            })
          }
        }
      } else if (this.$route.query.packageToken && !this.$route.query.memberId) {
        try {
          var idMember2 = moment().valueOf()
          const params = {
            name: this.profile.displayName.replace(/'/g, "\\'"),
            picture: this.profile.pictureUrl,
            tel: this.$route.query.shopId === this.$shopNameData.chubb
              ? this.form.tel.toUpperCase()
              : this.form.tel.split('-').join('').trim(),
            birthDay: this.form.bdDate,
            nameCustomer: this.form.nameCustomer,
            liffUserId: this.profile.userId,
            gender: this.gender,
            memberId: idMember2,
            shopId: this.$route.query.shopId,
            CONDITION_TERM1: this.checkTerm1,
            CONDITION_TERM2: this.checkTerm2,
            CREATE_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId,
            LAST_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId
          }
          const paramsCollect = {
            token: this.$route.query.packageToken
          }
          if (this.reFerId && this.reFerId.length > 6) {
            params.reFerId = this.reFerId
          }
          if (this.customFeild.length > 0) {
            let JSONvalueCustomFeild = JSON.stringify(this.valueCustomFeild)
            params.regisCustomFeild = JSONvalueCustomFeild
          }

          let result = await this.callBeTaskAPI(
            'post',
            `/member/addRegis`,
            params
          )
          if (result.message === 'tel is duplicate') {
            this.loadingbtn = false
            this.isProcessing = false
            await this.openOtpTelUpdateLine()
            return
          }
          if (result.status) {
            // const result2 = await this.callBeTaskAPI(
            await this.callBeTaskAPI(
              'post',
              `/collect_package/edit`,
              paramsCollect
            )
            if (this.$liff.isInClient()) {
              await this.getBotinfo()
              window.location.href = `https://line.me/R/oaMessage/${this.basicId}/?เปิดบัตรสะสมแต้ม(กรุณากดส่งข้อความนี้)`
            } else {
              window.location = this.getHomeUrl()
            }
          } else {
            this.loadingbtn = false
            if (result.message === 'tel is duplicate') {
            // Swal.fire({
            //   title: 'เบอร์โทรศัพท์ นี้ถูกเปิดใช้งานแล้ว',
            //   icon: 'error',
            //   showCancelButton: false,
            //   confirmButtonColor: '#3085d6',
            //   cancelButtonColor: '#b3b1ab',
            //   confirmButtonText: 'ตกลง'
            // }).then((confirm) => {
            //   if (confirm.isConfirmed) {
            //     this.form.tel = ''
            //   }
            // })
              await this.openOtpTelUpdateLine()
            } else {
              Swal.fire({
                title: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
                icon: 'error',
                showCancelButton: false,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#b3b1ab',
                confirmButtonText: 'ตกลง'
              }).then((confirm) => {
                if (confirm.isConfirmed) {
                  location.reload()
                } else {
                  location.reload()
                }
              })
            }
          }
        } catch (error) {
          this.loadingbtn = false
          this.isProcessing = false
          console.error('packageToken error:', error)
          Swal.fire({
            title: 'เกิดข้อผิดพลาด',
            text: error.message || 'กรุณาลองใหม่',
            icon: 'error',
            confirmButtonText: 'ตกลง'
          })
        }
      } else {
        Swal.fire({
          title: !this.$isEventShop(this.$route.query.shopId) ? `${this.$t('message.registorYet')}` : `${this.$t('message.registorYet2')}`,
          showCancelButton: true,
          allowOutsideClick: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: !this.$isEventShop(this.$route.query.shopId) ? `${this.$t('message.regisMember')}` : `${this.$t('message.register')}`,
          cancelButtonText: `${this.$t('message.cancle')}`
        }).then(async (confirm) => {
          if (confirm.isConfirmed) {
            // ร้านกันชา พี่ปอน
            if (this.$route.query.shopId === 'U43e7e7332135fa3253d4a1385a8a89ce') {
              this.dialogSetPin = true
            } else {
              var idMember = moment().valueOf()
              const params = {
                name: this.profile.displayName === '' || this.profile.displayName === null ? this.form.nameCustomer.replace(/'/g, "\\'") : this.profile.displayName.replace(/'/g, "\\'"),
                picture: this.profile.pictureUrl,
                tel: this.$route.query.shopId === this.$shopNameData.chubb
                  ? this.form.tel.trim().toUpperCase()
                  : this.form.tel.split('-').join('').trim(),
                gender: this.gender,
                birthDay: this.form.bdDate,
                nameCustomer: this.form.nameCustomer,
                liffUserId: this.profile.userId === '' || this.profile.userId === null ? null : this.profile.userId,
                memberId: idMember,
                shopId: this.$route.query.shopId,
                CONDITION_TERM1: this.checkTerm1,
                CONDITION_TERM2: this.checkTerm2,
                CREATE_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId,
                LAST_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId
              }
              if (this.reFerId && this.reFerId.length > 6) {
                params.reFerId = this.reFerId
              }
              if (this.remark) {
                params.remark = this.remark
              }
              if (this.form.email) {
                params.email = this.form.email
              }
              if (this.form.barcodeNum) {
                params.barcodeNum = this.form.barcodeNum
              }
              if (this.odooId) {
                params.refUID_anotherPlatfrom = this.odooId
              }
              if (this.$route.query.shopId !== 'U5bad3d6f53733785f626ceaeaad539f5') {
                if (this.customFeild.length > 0) {
                  let JSONvalueCustomFeild = JSON.stringify(this.valueCustomFeild)
                  params.regisCustomFeild = JSONvalueCustomFeild
                }
              } else {
                if (this.customFeild.length > 0) {
                  let JSONvalueCustomFeild = JSON.stringify(this.valueCustomFeild)
                  params.regisCustomFeild = JSONvalueCustomFeild
                }
              }

              if (this.$route.query.memberId) {
                // อัพเดท user ที่มีข้อมูล member card เเต่ไม่มีข้อมูล member
                // console.log('memberId', params)
                await this.callBeTaskAPI('post', `/member/update`, params)
                if (this.$liff.isInClient()) {
                  if (this.$route.query.shopId === 'SD_1749094171700') {
                    this.$liff
                      .sendMessages([
                        {
                          type: 'text',
                          text:
                            'เปิดใช้งานบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                            this.$route.query.memberId
                        }
                      ])
                      .then(() => {
                        if (this.$route.query.redirectUrl) {
                          window.location = this.$route.query.redirectUrl
                        } else {
                          window.location = this.getHomeUrl()
                        }
                        // this.$liff.closeWindow()
                      })
                      .catch((err) => {
                        console.error('error', err)
                      })
                  }
                } else {
                  if (this.$route.query.type === 'anotherlink') {
                    await this.setProfile(this.profile)
                    window.location = this.$route.query.redirectUrl
                  } else {
                    if (this.$route.query.likeToken) {
                      window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Loyalty`
                    } else {
                      if (this.$route.query.redirectUrl) {
                        await this.setProfile(this.profile)
                        window.location = this.$route.query.redirectUrl
                      } else {
                        await this.setProfile(this.profile)
                        this.$router.push(`/home?shopId=${this.$route.query.shopId}`)
                      }
                    }
                  }
                }
              } else {
                if (this.$route.query.odooId) {
                  params.refUID_anotherPlatfrom = this.$route.query.odooId
                }
                let result = await this.callBeTaskAPIActivity(
                  'post',
                  `/member/addRegis`,
                  params
                )
                if (result.message === 'tel is duplicate') {
                  await this.openOtpTelUpdateLine()
                  return
                }
                if (this.$route.query.shopId === 'U5bad3d6f53733785f626ceaeaad539f5') {
                  await this.callBeTaskAPI('post', `/StampCard/Regis`, params)
                } else if (this.$route.query.shopId === 'SD_1749094171700') {
                  await this.callBeTaskAPI('post', `/RXTradexStampCard/Regis`, params)
                } else if (this.$route.query.shopId === 'Ud9356d1cf189a31ab46cc5f424e14904') {
                  // ตาราง CGS_Member_Activity_Success ของงาน CGS เท่านั้น (ไม่มี shopId) ร้านอีเวนต์อื่นไม่ต้องเขียน
                  const paramsLink = {
                    memberId: params.memberId,
                    name: params.nameCustomer,
                    picture: params.picture,
                    liffUserId: params.liffUserId,
                    tel: params.tel
                  }
                  await axios.post(this.DNS_IP + `/CGS-activity-success/add`, paramsLink)
                }
                await this.setProfile(this.profile)
                this.isProcessing = false
                if (result.status === true) {
                  let swalOptions = {
                    title: 'สำเร็จ',
                    allowOutsideClick: false
                  }

                  if (this.$isTargetShop()) {
                    swalOptions.text = `ยินดีต้อนรับสู่ ${this.shopname}`
                    swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                    swalOptions.imageWidth = 100
                    swalOptions.imageHeight = 100
                    swalOptions.confirmButtonColor = '#FFD000'
                    swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
                  } else {
                    swalOptions.text = !this.$isEventShop(this.shopId) ? `${this.$t('message.welcomeToShop')}` : `${this.$t('message.succesRegis')}`
                    swalOptions.icon = 'success'
                    swalOptions.confirmButtonColor = '#3085d6'
                    swalOptions.confirmButtonText = 'รับทราบ'
                  }

                  Swal.fire(swalOptions)
                    .then(async (confirm) => {
                      // Redirect regardless of confirmation status
                      if (this.$liff.isInClient()) {
                        this.$liff
                          .sendMessages([
                            {
                              type: 'text',
                              text:
                                  'เปิดใช้งานบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                                  idMember
                            }
                          ])
                          .then(async () => {
                            if (this.$route.query.redirectUrl) {
                              window.location = this.$route.query.redirectUrl
                            } else {
                              if (this.source === 'flex') {
                                await this.getBotinfo()
                                window.location.href = `https://line.me/R/oaMessage/${this.basicId}/?เปิดบัตรสะสมแต้ม(กรุณากดส่งข้อความนี้)`
                              } else {
                                window.location = this.getHomeUrl()
                              }
                              // window.location = this.getHomeUrl()
                            }
                            // this.$liff.closeWindow()
                          })
                        // eslint-disable-next-line handle-callback-err
                          .catch((err) => {
                            if (this.$route.query.redirectUrl) {
                              window.location = this.$route.query.redirectUrl
                            } else {
                              window.location = this.getHomeUrl()
                            }
                          })
                      } else {
                        if (this.$route.query.type === 'anotherlink') {
                          window.location = this.$route.query.redirectUrl
                        } else {
                          if (this.$route.query.likeToken) {
                            window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Loyalty`
                          } else {
                            if (this.$route.query.redirectUrl) {
                              window.location = this.$route.query.redirectUrl
                            } else {
                              window.location = this.getHomeUrl()
                            }
                          }
                        }
                      }
                    })
                    .catch((err) => {
                      console.error('error', err)
                      window.location = this.getHomeUrl()
                    })
                  // if (this.$liff.isInClient()) {
                  //   this.$liff
                  //     .sendMessages([
                  //       {
                  //         type: 'text',
                  //         text:
                  //         'เปิดใช้งานบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                  //         idMember
                  //       }
                  //     ])
                  //     .then(() => {
                  //       console.log('message sent')
                  //       if (this.$route.query.redirectUrl) {
                  //         window.location = this.$route.query.redirectUrl
                  //       } else {
                  //         this.$router.push(`/home?shopId=${this.$route.query.shopId}`)
                  //       }
                  //     // this.$liff.closeWindow()
                  //     })
                  //     .catch((err) => {
                  //       console.log('error', err)
                  //     })
                  // } else {
                  //   if (this.$route.query.type === 'anotherlink') {
                  //     this.$router.push(this.$route.query.redirectUrl)
                  //   } else {
                  //     if (this.$route.query.likeToken) {
                  //       window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Loyalty`
                  //     } else {
                  //       if (this.$route.query.redirectUrl) {
                  //         window.location = this.$route.query.redirectUrl
                  //       } else {
                  //         this.$router.push(`/home?shopId=${this.$route.query.shopId}`)
                  //       }
                  //     }
                  //   }
                  // }
                } else {
                  this.loadingbtn = false
                  this.isProcessing = false
                  if (result.message === 'tel is duplicate') {
                    // Swal.fire({
                    //   title: 'เบอร์โทรศัพท์ นี้ถูกเปิดใช้งานแล้ว',
                    //   icon: 'error',
                    //   showCancelButton: false,
                    //   confirmButtonColor: '#3085d6',
                    //   cancelButtonColor: '#b3b1ab',
                    //   confirmButtonText: 'ตกลง'
                    // }).then((confirm) => {
                    //   if (confirm.isConfirmed) {
                    //     this.form.tel = ''
                    //   }
                    // })
                    await this.openOtpTelUpdateLine()
                  } else {
                    Swal.fire({
                      title: result.message,
                      icon: 'error',
                      showCancelButton: false,
                      confirmButtonColor: '#3085d6',
                      cancelButtonColor: '#b3b1ab',
                      confirmButtonText: 'ตกลง'
                    }).then((confirm) => {
                      if (confirm.isConfirmed) {
                        location.reload()
                      } else {
                        location.reload()
                      }
                    })
                  }
                }
              }
            }
          } else {
            this.loadingbtn = false
            this.isProcessing = false
          }
        })
        this.loadingbtn = false
        this.isProcessing = false
      }
    },
    async onSubmitBelinkAndRoyalty () {
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      let paramsRoyalty = {}
      if (this.$route.query.type === 'VLinked') {
        paramsRoyalty = {
          name: this.profile.displayName.replace(/'/g, "\\'"),
          picture: this.profile.pictureUrl,
          tel: this.form.tel.split('-').join('').trim(),
          birthDay: this.form.bdDate,
          nameCustomer: this.form.nameCustomer,
          gender: this.gender,
          liffUserId: this.profile.userId,
          memberId: idMember,
          shopId: this.$route.query.shopId,
          lineUserIdVLinked: this.$route.query.lineUserIdVLinked,
          CONDITION_TERM1: this.checkTerm1,
          CONDITION_TERM2: this.checkTerm2,
          CREATE_USER: this.profile.userId,
          LAST_USER: this.profile.userId
        }
      } else {
        paramsRoyalty = {
          name: this.profile.displayName === '' || this.profile.displayName === null ? this.form.nameCustomer.replace(/'/g, "\\'") : this.profile.displayName.replace(/'/g, "\\'"),
          picture: this.profile.pictureUrl,
          tel: this.form.tel.split('-').join('').trim(),
          gender: this.gender,
          birthDay: this.form.bdDate,
          nameCustomer: this.form.nameCustomer,
          liffUserId: this.profile.userId === '' || this.profile.userId === null ? null : this.profile.userId,
          memberId: idMember,
          shopId: this.$route.query.shopId,
          CONDITION_TERM1: this.checkTerm1,
          CONDITION_TERM2: this.checkTerm2,
          CREATE_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId,
          LAST_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId
        }
      }
      const paramsLink = {
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        shopId: this.$route.query.shopId,
        memberId: idMember,
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      }
      const resultLink = await axios.post(
        this.DNS_Link + `/member/add`,
        paramsLink
      )
      if (this.reFerId && this.reFerId.length > 6) {
        paramsRoyalty.reFerId = this.reFerId
      }
      if (this.customFeild.length > 0) {
        let JSONvalueCustomFeild = JSON.stringify(this.valueCustomFeild)
        paramsRoyalty.regisCustomFeild = JSONvalueCustomFeild
      }
      let resultRoyalty = await this.callBeTaskAPIActivity(
        'post',
        `/member/addRegis`,
        paramsRoyalty
      )
      if (resultRoyalty.message === 'tel is duplicate') {
        await this.openOtpTelUpdateLine()
        return
      }
      if (this.$route.query.token) {
        const paramsCollect = {
          token: this.$route.query.token
        }
        if (resultRoyalty.status) {
          await this.callBeTaskAPI('post', `/memberCard/edit`, paramsCollect)
        }
      }
      if (resultLink.data.status && resultRoyalty.status) {
        let swalOptions = {
          title: 'สำเร็จ'
        }

        if (this.$isTargetShop()) {
          swalOptions.text = `ยินดีต้อนรับสู่ ${this.shopName}`
          swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
          swalOptions.imageWidth = 100
          swalOptions.imageHeight = 100
          swalOptions.confirmButtonColor = '#FFD000'
          swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
        } else {
          swalOptions.text = `ยินดีต้อนรับสู่ร้านค้าของเรา`
          swalOptions.icon = 'success'
          swalOptions.confirmButtonColor = '#3085d6'
          swalOptions.confirmButtonText = 'รับทราบ'
        }

        Swal.fire(swalOptions)

          .then((confirm) => {
            if (confirm.isConfirmed) {
              window.location = this.getHomeUrl()
            } else {
              window.location = this.getHomeUrl()
            }
          })
          .catch((err) => {
            console.error('error', err)
            this.$router.push('/bankPage')
          })
        // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
        // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
        if (this.$liff.isInClient()) {
          this.$liff
            .sendMessages([
              {
                type: 'text',
                text:
                  'เปิดรับการแจ้งเตือนและบัตรสะสมแต้มเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                  idMember
              }
            ])
            .then(async () => {
              if (this.source === 'flex') {
                await this.getBotinfo()
                window.location.href = `https://line.me/R/oaMessage/${this.basicId}/?เปิดบัตรสะสมแต้ม(กรุณากดส่งข้อความนี้)`
              } else {
                window.location = this.getHomeUrl()
              }
            })
            .catch((err) => {
              console.error('error', err)
            })
        } else {
          window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-loyaltyLinked`
        }
      } else {
        this.loadingbtn = false
        if (resultRoyalty.message === 'tel is duplicate') {
          // Swal.fire({
          //   title: 'เบอร์โทรศัพท์ นี้ถูกเปิดใช้งานแล้ว',
          //   icon: 'error',
          //   showCancelButton: false,
          //   confirmButtonColor: '#3085d6',
          //   cancelButtonColor: '#b3b1ab',
          //   confirmButtonText: 'ตกลง'
          // }).then((confirm) => {
          //   if (confirm.isConfirmed) {
          //     this.form.tel = ''
          //   }
          // })
          await this.openOtpTelUpdateLine()
        } else {
          Swal.fire({
            title: 'ผิดพลาด',
            text: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
            icon: 'error',
            confirmButtonText: 'รับทราบ',
            confirmButtonColor: '#3085d6'
          })
            .then((confirm) => {
              if (confirm.isConfirmed) {
                location.reload()
              } else {
                location.reload()
              }
            })
            .catch((err) => {
              console.error('error', err)
              location.reload()
            })
        }
      }
    },
    async onSubmitBelink (a) {
      // var idMember = 'Link_' + Date.now()
      var idMember = moment().valueOf()
      const params = {
        name: a.name,
        picture: a.picture,
        liffUserId: a.liffUserId,
        shopId: a.shopId,
        memberId: idMember,
        CREATE_USER: a.CREATE_USER,
        LAST_USER: a.LAST_USER
      }
      const result = await axios.post(this.DNS_Link + `/member/add`, params)
      await this.setProfile(this.profile)
      if (result.status) {
        // Swal.fire('สำเร็จ!', 'ยินดีต้อนรับสู่ร้านค้าของเรา', 'success')
        let swalOptions = {
          title: 'สำเร็จ'
        }

        if (this.$isTargetShop()) {
          swalOptions.text = `ยินดีต้อนรับสู่ ${this.shopname}`
          swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
          swalOptions.imageWidth = 100
          swalOptions.imageHeight = 100
          swalOptions.confirmButtonColor = '#FFD000'
          swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
        } else {
          swalOptions.text = `ยินดีต้อนรับสู่ร้านค้าของเรา`
          swalOptions.icon = 'success'
          swalOptions.confirmButtonColor = '#3085d6'
          swalOptions.confirmButtonText = 'รับทราบ'
        }

        Swal.fire(swalOptions)
        // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
        // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
        if (this.$liff.isInClient()) {
          this.$liff
            .sendMessages([
              {
                type: 'text',
                text:
                  'เปิดรับการแจ้งเตือนเรียบร้อย หมายเลขสมาชิกของคุณคือ ' +
                  idMember
              }
            ])
            .then(() => {
              if (this.$route.query.token) {
                this.$router.push('/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token)
              } else {
                let swalOptions = {
                  title: `${this.$t('message.alreadyRegis')}`,
                  confirmButtonText: `รับทราบ`,
                  confirmButtonColor: '#3085d6'
                }

                if (this.$isTargetShop()) {
                  swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                  swalOptions.imageWidth = 100
                  swalOptions.imageHeight = 100
                  swalOptions.confirmButtonColor = '#FFD000'
                  swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
                } else {
                  swalOptions.icon = 'success'
                }

                Swal.fire(swalOptions)
                  .then((confirm) => {
                    if (confirm.isConfirmed) {
                      window.location = this.getHomeUrl()
                    } else {
                      window.location = this.getHomeUrl()
                    }
                  })
                  .catch((err) => {
                    console.error('error', err)
                    window.location = this.getHomeUrl()
                  })
                // window.location = this.getHomeUrl()
              }
            })
            .catch((err) => {
              console.error('error', err)
            })
        } else {
          window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Linked`
        }
      } else {
        this.$swal({
          title: 'เกิดข้อผิดพลาด กรุณาลองใหม่',
          icon: 'error',
          showCancelButton: false,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#b3b1ab',
          confirmButtonText: 'ตกลง'
        }).then((confirm) => {
          if (confirm.isConfirmed) {
            location.reload()
          }
        })
      }
    },
    async onUpdateBelink (idMember) {
      // window.location.replace(`https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`)
      // window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}`
      if (this.$liff.isInClient()) {
        this.$liff
          .sendMessages([
            {
              type: 'text',
              text: 'คุณทำรายการนี้ไปแล้ว หมายเลขสมาชิกของคุณคือ ' + idMember
            }
          ])
          .then(() => {
            if (this.$route.query.token) {
              this.$router.push('/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token)
            } else {
              let swalOptions = {
                title: `${this.$t('message.alreadyRegis')}`,
                confirmButtonText: `รับทราบ`,
                confirmButtonColor: '#3085d6'
              }

              if (this.$isTargetShop()) {
                swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                swalOptions.imageWidth = 100
                swalOptions.imageHeight = 100
                swalOptions.confirmButtonColor = '#FFD000'
                swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
              } else {
                swalOptions.icon = 'success'
              }

              Swal.fire(swalOptions)
                .then((confirm) => {
                  if (confirm.isConfirmed) {
                    if (this.$route.query.shopId === 'SD_1749094171700') {
                      this.$router.push('/StampRXTradex')
                      window.location = '/StampRXTradex'
                      return
                    }
                    window.location = this.getHomeUrl()
                  } else {
                    if (this.$route.query.shopId === 'SD_1749094171700') {
                      this.$router.push('/StampRXTradex')
                      window.location = '/StampRXTradex'
                      return
                    }
                    window.location = this.getHomeUrl()
                  }
                })
                .catch((err) => {
                  console.error('error', err)
                  window.location = this.getHomeUrl()
                })
            }
          })
          .catch((err) => {
            console.error('error', err)
          })
      } else {
        if (this.$route.query.likeToken) {
          window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Linked`
        } else {
          const homeUrl = this.getHomeUrl()

          let swalOptions = {
            title: `${this.$t('message.alreadyRegis')}`,
            text: this.isTargetShop ? '' : 'กดปุ่ม "เปลี่ยนไลน์เบอร์เดิม" หากต้องการโอนย้ายข้อมูล',
            confirmButtonText: `รับทราบ`,
            showCancelButton: !this.isTargetShop,
            cancelButtonText: 'เปลี่ยนไลน์เบอร์เดิม',
            cancelButtonColor: '#ffa300',
            allowOutsideClick: false,
            reverseButtons: true
          }

          if (this.$isTargetShop()) {
            swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
            swalOptions.imageWidth = 100
            swalOptions.imageHeight = 100
            swalOptions.confirmButtonColor = '#FFD000'
            swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
          } else {
            swalOptions.icon = 'warning'
            swalOptions.confirmButtonColor = '#3085d6'
            swalOptions.confirmButtonText = 'รับทราบ'
          }

          Swal.fire(swalOptions)
            .then(async (confirm) => {
              if (confirm.isConfirmed) {
                if (this.$route.query.shopId === 'SD_1749094171700') {
                  this.$router.push('/StampRXTradex')
                  window.location.href = '/StampRXTradex'
                  return
                }
                window.location.href = homeUrl
              } else {
                if (this.$route.query.shopId === 'SD_1749094171700') {
                  this.$router.push('/StampRXTradex')
                  window.location.href = '/StampRXTradex'
                  return
                }
                if (confirm.isDismissed) {
                  await this.openOtpTelUpdateLine()
                  return
                }
                window.location.href = homeUrl
              }
            })
            .catch((err) => {
              console.error('🔴 Swal.catch error:', err)
              console.error('🟢 error fallback redirect to:', homeUrl)
              window.location.href = homeUrl
            })
        }
      }
    },
    async onUpdate (idMember) {
      if (this.$liff.isInClient()) {
        this.$liff
          .sendMessages([
            {
              type: 'text',
              text:
                'คุณเปิดใช้งานบัตรสะสมแต้มไปแล้ว หมายเลขสมาชิกของคุณคือ ' +
                idMember
            }
          ])
          .then(() => {
            if (this.$route.query.token) {
              this.$router.push('/collect?shopId=' + this.$route.query.shopId + '&token=' + this.$route.query.token)
            } else {
              let swalOptions = {
                title: `${this.$t('message.alreadyRegis')}`,
                confirmButtonText: `รับทราบ`,
                confirmButtonColor: '#3085d6'
              }

              if (this.$isTargetShop()) {
                swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                swalOptions.imageWidth = 100
                swalOptions.imageHeight = 100
                swalOptions.confirmButtonColor = '#FFD000'
                swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
              } else {
                swalOptions.icon = 'success'
              }

              Swal.fire(swalOptions)
                .then((confirm) => {
                  if (confirm.isConfirmed) {
                    if (this.$route.query.shopId === 'SD_1749094171700') {
                      this.$router.push('/StampRXTradex')
                      window.location = '/StampRXTradex'
                      return
                    }
                    window.location = this.getHomeUrl()
                  } else {
                    if (this.$route.query.shopId === 'SD_1749094171700') {
                      this.$router.push('/StampRXTradex')
                      window.location = '/StampRXTradex'
                      return
                    }
                    window.location = this.getHomeUrl()
                  }
                })
                .catch((err) => {
                  console.error('error', err)
                  window.location = this.getHomeUrl()
                })
            }
          })
          .catch((err) => {
            console.error('error', err)
          })
      } else {
        if (this.$route.query.likeToken) {
          window.location.href = `https://access.line.me/dialog/bot/accountLink?linkToken=${this.$route.query.likeToken}&nonce=${idMember}-${this.profile.userId}-Linked`
        } else {
          const homeUrl = this.getHomeUrl()

          let swalOptions = {
            title: `${this.$t('message.alreadyRegis')}`,
            text: this.isTargetShop ? '' : 'กดปุ่ม "เปลี่ยนไลน์เบอร์เดิม" หากต้องการโอนย้ายข้อมูล',
            confirmButtonText: `รับทราบ`,
            showCancelButton: !this.isTargetShop,
            cancelButtonText: 'เปลี่ยนไลน์เบอร์เดิม',
            cancelButtonColor: '#ffa300',
            allowOutsideClick: false,
            reverseButtons: true
          }

          if (this.$isTargetShop()) {
            swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
            swalOptions.imageWidth = 100
            swalOptions.imageHeight = 100
            swalOptions.confirmButtonColor = '#FFD000'
            swalOptions.confirmButtonText = `<span style="color:#000000">รับทราบ<span>`
          } else {
            swalOptions.icon = 'warning'
            swalOptions.confirmButtonColor = '#3085d6'
          }

          Swal.fire(swalOptions)
            .then(async (confirm) => {
              if (confirm.isConfirmed) {
                if (this.$route.query.shopId === 'SD_1749094171700') {
                  this.$router.push('/StampRXTradex')
                  window.location.href = '/StampRXTradex'
                  return
                }
                window.location.href = homeUrl
              } else {
                if (this.$route.query.shopId === 'SD_1749094171700') {
                  this.$router.push('/StampRXTradex')
                  window.location.href = '/StampRXTradex'
                  return
                }
                if (confirm.isDismissed) {
                  await this.openOtpTelUpdateLine()
                  return
                }
                window.location.href = homeUrl
              }
            })
            .catch((err) => {
              console.error('🔴 onUpdate Swal.catch error:', err)
              console.error('🟢 onUpdate - error fallback redirect to:', homeUrl)
              window.location.href = homeUrl
            })
        }
      }
    },
    async getBotinfo (idMember) {
      // let token = this.$liff.getAccessToken()
      if (this.$route.query.shopId) {
        const url = `${this.DNS_IP}/line/getOa`
        const config = {
          headers: {
            botId: this.$route.query.shopId
          }
        }
        await axios.get(url, config).then((response) => {
          let rs = response.data
          this.basicId = rs.basicId
          window.location.href = 'line://ti/p/' + rs.basicId
        })
      }
    },
    async callBeTaskAPIActivity (method, url, params) {
      let result = null
      //   const token = this.$liff.getAccessToken() || '1234567890'
      await axios({
        method: method,
        // headers: {
        //   accessToken: token,
        //   lineUserId: this.profile.userId,
        //   activityId: this.formUpdate.activityId
        // },
        url: this.DNS_IP + url,
        data: params
      })
        .then((response) => {
          result = response.data
        })
        .catch((error) => {
          console.error(error)
          result = null
        })
      return result
    },
    async getCustomFeild () {
      const result = await this.callBeTaskAPI(
        'get',
        `/CustomField/get?shopId=${this.$route.query.shopId}&showCard=True`
      )
      if (result) {
        if (Array.isArray(result)) {
          this.hiddenSystemFields = result.filter(i => i.fieldType === 'hideSystemField').map(i => i.fieldName)
          this.customFeild = result.filter(i => i.fieldType !== 'hideSystemField')
          for (let i = 0; i < this.customFeild.length; i++) {
            let obj = {}
            obj['customFeildName'] = this.customFeild[i].fieldName
            this.valueCustomFeild.push(obj)
          }
          this.customFeild.forEach(item => {
            if (item.fieldType === 'email') {
              this.emailCheckStatus = true
            }
          })
        }
        // console.log('this.customFeild', this.customFeild)
        // console.log('this.valueCustomFeild', this.valueCustomFeild)
      }
    },
    async onSubmitKKEandLin () {
      // this.$refs.form_add.validate()
      if (this.$refs.form_add.validate() === true) {
        if (this.filesAdd) {
          let paramsPic = new FormData()
          paramsPic.append('file', this.filesAdd[0])
          const response = await axios.post(this.DNS_IP + `/file/upload/profilePic`, paramsPic)
          this.profileUrl = response.data
        }
        const activeShopId = String(this.$route.query.shopId || this.shopId || this.GET_SHOPID() || '').trim()
        if (this.theme.barCodeData === 'True' || activeShopId === this.$shopNameData.chubb) {
          if (activeShopId === this.$shopNameData.chubb) {
            // chubb ใช้เบอร์โทรเป็น barcode (เป็นตัวเลข) uppercase ได้ปลอดภัย
            this.form.barcodeNum = this.form.tel.trim().toUpperCase()
          } else {
            // ร้านอื่น barcode/รหัสสมาชิกอาจ case-sensitive คงตัวพิมพ์เดิม trim เฉพาะช่องว่าง
            this.form.barcodeNum = (this.form.barcodeNum || '').trim()
          }
          const data = await axios.get(this.DNS_IP + `/BarcodeMember/get?barcodeNum=${encodeURIComponent(this.form.barcodeNum)}&shopId=${encodeURIComponent(activeShopId)}`)
          if (Array.isArray(data.data)) {
            if (data.data[0].activate === 'False') {
              // const dataChecktel = await axios.get(this.DNS_IP + `/member/get?tel=${this.form.barcodeNum}&shopId=${this.shopId}`)
              // const params = {
              //   name: this.profile.displayName === '' || this.profile.displayName === null ? this.form.nameCustomer.replace(/'/g, "\\'") : this.profile.displayName.replace(/'/g, "\\'"),
              //   picture: this.profileUrl || 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2',
              //   tel: this.form.tel.split('-').join('').trim(),
              //   gender: this.gender,
              //   birthDay: this.form.bdDate,
              //   memberId: this.form.memberId,
              //   nameCustomer: this.form.nameCustomer,
              //   liffUserId: this.profile.userId === '' || this.profile.userId === null ? null : this.profile.userId,
              //   shopId: this.$route.query.shopId,
              //   CONDITION_TERM1: this.checkTerm1,
              //   CONDITION_TERM2: this.checkTerm2,
              //   CREATE_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId,
              //   LAST_USER: this.profile.userId === '' || this.profile.userId === null ? this.form.tel.split('-').join('').trim() : this.profile.userId
              // }
              // console.log('params', params)
              if (activeShopId !== this.$shopNameData.chubb && activeShopId !== 'Ub067d158c52aaaec79b67cfc997fda79') {
                const result = await axios.post(this.DNS_IP + `/OTP/registor`, { 'tel': this.form.tel.split('-').join('').trim(), 'shopId': activeShopId, 'language': this.$i18n.locale })
                if (result.data.status === true) {
                  this.otpPassword = ''
                  this.dialogOTP = true
                } else {
                  Swal.fire({
                    title: `${this.$t('message.thisTelNotUsed')}`,
                    icon: 'error',
                    confirmButtonText: `${this.$t('message.ok')}`,
                    confirmButtonColor: '#3085d6'
                  }).then(async (confirm) => {
                    if (confirm.isConfirmed) {
                      this.loadingbtn = false
                    }
                  })
                    .catch((err) => {
                      console.error('error', err)
                    })
                }
              } else {
                if (activeShopId === 'Ub067d158c52aaaec79b67cfc997fda79') {
                  let data = await axios.post(this.DNS_IP + `/Checkandupdate/spendpoint`, { 'barcodeNum': this.form.barcodeNum, 'tel': this.form.tel.split('-').join('').trim() })
                  if (data.data.status === true) {
                    await this.onSubmit()
                  } else {
                    Swal.fire({
                      title: `${this.$t('message.fail')}`,
                      text: `${this.$t('message.contract')}` + ' ' + this.form.barcodeNum + `${this.$t('message.andTel')} ` + this.form.tel.split('-').join('').trim() + ` ${this.$t('message.notmatchTel')}`,
                      icon: 'error',
                      confirmButtonText: `${this.$t('message.ok')}`,
                      confirmButtonColor: '#3085d6'
                    })
                      .then((confirm) => {
                        if (confirm.isConfirmed) {
                          this.loadingbtn = false
                        } else {
                        }
                      })
                      .catch((err) => {
                        console.error('error', err)
                        // window.location = this.getHomeUrl()
                      })
                  }
                } else {
                  await this.onSubmit()
                }
              }
            } else {
              Swal.fire({
                title: `${this.$t('message.fail')}`,
                text: `${activeShopId === 'Ub067d158c52aaaec79b67cfc997fda79' ? this.$t('message.contract') : this.$t('message.barcode')}` + ' ' + this.form.barcodeNum + ' ' + `${this.$t('message.already')}`,
                icon: 'error',
                confirmButtonText: `${this.$t('message.ok')}`,
                confirmButtonColor: '#3085d6'
              })
                .then((confirm) => {
                  if (confirm.isConfirmed) {
                    this.loadingbtn = false
                  } else {
                  }
                })
                .catch((err) => {
                  console.error('error', err)
                  // window.location = this.getHomeUrl()
                })
            }
          } else {
            if (activeShopId === this.$shopNameData.chubb) {
              await this.onSubmit()
            } else {
              Swal.fire({
                title: `${this.$t('message.fail')}`,
                text: `${this.$t('message.notFoundThisMemberId')} ` + this.form.barcodeNum,
                icon: 'error',
                confirmButtonText: `${this.$t('message.ok')}`,
                confirmButtonColor: '#3085d6'
              })
                .then((confirm) => {
                  if (confirm.isConfirmed) {
                    this.loadingbtn = false
                    // window.location = this.getHomeUrl()
                  } else {
                    // window.location = this.getHomeUrl()
                  }
                })
                .catch((err) => {
                  console.error('error', err)
                  // window.location = this.getHomeUrl()
                })
            }
          }
        } else {
          const result = await axios.post(this.DNS_IP + `/OTP/registor`, { 'tel': this.form.tel.split('-').join('').trim(), 'shopId': this.$route.query.shopId, 'language': this.$i18n.locale })
          if (result.data.status === true) {
            this.otpPassword = ''
            this.dialogOTP = true
          } else {
            Swal.fire({
              title: `${this.$t('message.thisTelAlready')}`,
              icon: 'error',
              confirmButtonText: `${this.$t('message.ok')}`,
              confirmButtonColor: '#3085d6'
            }).then(async (confirm) => {
              if (confirm.isConfirmed) {
                this.loadingbtn = false
              }
            })
              .catch((err) => {
                console.error('error', err)
              })
          }
        }
      }
    },
    async postOTP () {
      const result = await axios.post(this.DNS_IP + `/OTP/registor`, { 'tel': this.form.tel.split('-').join('').trim(), 'shopId': this.$route.query.shopId, 'language': this.$i18n.locale })
      if (result.data.status === true) {
        this.dialogOTPUpdateLine = false
        this.dialogOTPPassword = true
      } else {
        this.loadingbtn = false
        await Swal.fire({
          title: `${this.$t('message.thisTelAlready')}`,
          icon: 'error',
          confirmButtonText: `${this.$t('message.ok')}`,
          confirmButtonColor: '#3085d6'
        })
        throw new Error('OTP send failed')
      }
    },
    async onUpdateLine (params) {
      // เพิ่ม tel ใน params
      params.tel = this.form.tel.split('-').join('').trim()
      await axios.post(this.DNS_IP + `/OTP/updateLineUserId`, params)
    },
    async executeLineUpdate () {
      const result = await Swal.fire({
        title: `${this.$t('message.confirm') || 'Confirm'}`,
        text: `จะทำการย้ายรายการเลือก?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('message.yes') || 'Yes',
        cancelButtonText: this.$t('message.cancle') || 'Cancel'
      })

      if (result.isConfirmed) {
        const allIds = (this.responseCheck || []).map(v => this.getItemId(v)).filter(Boolean)
        const unselected = allIds.filter(memberId => memberId !== this.selectedId)
        await this.deleteUnselected(unselected)
      }

      await this.onUpdateLine({
        name: this.profile.displayName,
        picture: this.profile.pictureUrl,
        liffUserId: this.profile.userId,
        shopId: this.$route.query.shopId,
        CREATE_USER: this.profile.userId,
        LAST_USER: this.profile.userId
      })
      this.dialogOTPPassword = false
      window.location = this.getHomeUrl()
    },
    async otpCheckAndUpdateLine () {
      // console.log('this.otpPassword', this.otpPassword)
      const data = await axios.get(this.DNS_IP + `/otp/get?tel=${this.form.tel.split('-').join('').trim()}`)
      if (data.data[0].otpPassword === this.otpPassword) {
        this.dialogOTPPassword = false
        await this.executeLineUpdate()
      } else {
        Swal.fire({
          title: `${this.$t('message.fail')}`,
          text: `${this.$t('message.incorrectOtp')}`,
          icon: 'error',
          confirmButtonText: `${this.$t('message.ok')}`,
          confirmButtonColor: '#3085d6'
        })
          .then((confirm) => {
            if (confirm.isConfirmed) {
              this.loadingbtn = false
              this.otpPassword = ''
              // window.location = this.getHomeUrl()
            } else {
              // window.location = this.getHomeUrl()
            }
          })
          .catch((err) => {
            console.error('error', err)
            // window.location = this.getHomeUrl()
          }).finally(() => {
            this.dialogOTPPassword = false
          })
      }
    },
    async otpCheck () {
      // console.log('this.otpPassword', this.otpPassword)
      const data = await axios.get(this.DNS_IP + `/otp/get?tel=${this.form.tel.split('-').join('').trim()}`)
      if (data.data[0].otpPassword === this.otpPassword) {
        this.otpVerified = true
        this.dialogOTP = false
        // Check if shop requires PIN (e.g. ร้านกันชา)
        if (this.$route.query.shopId === 'U43e7e7332135fa3253d4a1385a8a89ce') {
          this.dialogSetPin = true
        } else {
          await this.onSubmit()
        }
      } else {
        Swal.fire({
          title: `${this.$t('message.fail')}`,
          text: `${this.$t('message.incorrectOtp')}`,
          icon: 'error',
          confirmButtonText: `${this.$t('message.ok')}`,
          confirmButtonColor: '#3085d6'
        })
          .then((confirm) => {
            if (confirm.isConfirmed) {
              this.loadingbtn = false
              this.otpPassword = ''
              // window.location = this.getHomeUrl()
            } else {
              // window.location = this.getHomeUrl()
            }
          })
          .catch((err) => {
            console.error('error', err)
            // window.location = this.getHomeUrl()
          })
      }
    },
    inputPin (item) {
      if (this.createPinNumber.length < 6) {
        this.createPinNumber = this.createPinNumber + item
        if (this.createPinNumber.length === 6) {
          this.overlay = true
          setTimeout(() => {
            this.dialogConfirmPin = true
          }, 500)
        }
      }
    },
    deletePin () {
      this.createPinNumber = this.createPinNumber.slice(0, -1)
    },
    async inputPinConfirm (item) {
      if (this.conFirmPinNumber.length < 6) {
        this.conFirmPinNumber = this.conFirmPinNumber + item
        if (this.conFirmPinNumber.length === 6) {
          if (this.createPinNumber === this.conFirmPinNumber) {
            this.overlayConfirmPin = true
            var idMember = moment().valueOf()
            let profile = await this.getLiffProfile()
            // this.profile.pictureUrl
            // this.profile.displayName
            // this.profileUrl || 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
            const params = {
              name: profile.displayName ? profile.displayName.replace(/'/g, "\\'") : this.form.nameCustomer.replace(/'/g, "\\'"),
              picture: profile.pictureUrl ? profile.pictureUrl : this.profileUrl ? this.profileUrl : 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2',
              tel: this.form.tel.split('-').join('').trim(),
              gender: this.gender,
              birthDay: this.form.bdDate,
              memberId: idMember,
              nameCustomer: this.form.nameCustomer,
              liffUserId: profile.userId === '' || profile.userId === null ? '' : profile.userId,
              shopId: this.$route.query.shopId,
              CONDITION_TERM1: this.checkTerm1,
              CONDITION_TERM2: this.checkTerm2,
              CREATE_USER: profile.userId === '' || profile.userId === null ? this.form.tel.split('-').join('').trim() : profile.userId,
              LAST_USER: profile.userId === '' || profile.userId === null ? this.form.tel.split('-').join('').trim() : profile.userId,
              barcodeNum: this.form.barcodeNum,
              pin_number: this.createPinNumber
            }
            if (this.reFerId && this.reFerId.length > 6) {
              params.reFerId = this.reFerId
            }
            if (this.customFeild.length > 0) {
              let JSONvalueCustomFeild = JSON.stringify(this.valueCustomFeild)
              params.regisCustomFeild = JSONvalueCustomFeild
            }
            if (this.$route.query.branchId) {
              const params = {
                tel: this.form.tel.split('-').join('').trim(),
                memberId: idMember,
                lineUserId: profile.userId === '' || profile.userId === null ? '' : profile.userId,
                shopId: this.$route.query.shopId,
                branchId: this.$route.query.branchId
              }
              await this.callBeTaskAPIActivity(
                'post',
                `/lineUserID_Multi_Provider/insert`,
                params
              )
            }
            // this.profile.tel = this.tel
            this.profile.memberId = idMember
            this.profile.userId = profile.userId === '' || profile.userId === null ? '' : profile.userId
            this.profile.displayName = profile.displayName || this.form.nameCustomer
            this.profile.pictureUrl = profile.pictureUrl ? profile.pictureUrl : this.profileUrl ? this.profileUrl : 'https://firebasestorage.googleapis.com/v0/b/betask-loyalty.appspot.com/o/user.png?alt=media&token=b9e270ee-8367-489f-8693-03499508dcd2'
            // console.log('params', this.profile)
            // console.log('params', profile)
            // console.log('params', params)
            // console.log('params', this.profile)
            let result = await this.callBeTaskAPIActivity(
              'post',
              `/member/addRegis`,
              params
            )
            if (result.message === 'tel is duplicate') {
              await this.openOtpTelUpdateLine()
              return
            }
            if (result.status === true) {
              await this.setProfile(this.profile)
              let swalOptions = {
                title: `${this.$t('message.complete')}`,
                confirmButtonText: `${this.$t('message.ok')}`
              }

              if (this.$isTargetShop()) {
                swalOptions.imageUrl = 'https://storage.googleapis.com/betask-loyalty.appspot.com/static/upload/activity/ACT3399_20250305135620796260.png'
                swalOptions.imageWidth = 100
                swalOptions.imageHeight = 100
                swalOptions.color = '#000000'
                swalOptions.confirmButtonColor = '#FFD000'
                swalOptions.text = `ยินดีต้อนรับสู่ ${this.shopname}`
              } else {
                swalOptions.text = `${this.$t('message.welcomeToShop')}`
                swalOptions.icon = 'success'
                swalOptions.confirmButtonColor = '#3085d6'
              }

              Swal.fire(swalOptions).then(async (confirm) => {
                if (confirm.isConfirmed) {
                  if (this.$route.query.redirectUrl) {
                    window.location = this.$route.query.redirectUrl
                  } else {
                    this.$router.push('/')
                  }
                }
              })
                .catch((err) => {
                  console.error('error', err)
                  this.$router.push('/bankPage')
                })
            }
          } else {
            // alert('ไม่เหมือน')
            Swal.fire({
              title: `${this.$t('message.pinNotMatch')}`,
              icon: 'error',
              confirmButtonText: `${this.$t('message.ok')}`,
              confirmButtonColor: '#3085d6'
            }).then(async (confirm) => {
              if (confirm.isConfirmed) {
                this.conFirmPinNumber = ''
              }
            })
              .catch((err) => {
                console.error('error', err)
                // this.$router.push('/bankPage')
              })
          }
        }
      }
    },
    deletePinConfirm () {
      this.conFirmPinNumber = this.conFirmPinNumber.slice(0, -1)
    }
  }
}
</script>
<style scoped>
.friend-gate { position: fixed; inset: 0; z-index: 20; background: rgba(0, 0, 0, 0.55); display: flex; align-items: center; justify-content: center; padding: 16px; }
.friend-gate__card { background: #fff; border-radius: 16px; padding: 24px 20px; width: 100%; max-width: 360px; text-align: center; }
.friend-gate__title { font-size: 18px; font-weight: bold; margin-bottom: 6px; }
.friend-gate__text { font-size: 14px; color: #616161; margin-bottom: 16px; }
.sheet-form-order {
  display: flex;
  flex-direction: column;
}
.sheet-form-order > * {
  order: 3;
}
.sheet-form-order > .sheet-order-name {
  order: 0;
}
.sheet-form-order > .sheet-order-custom {
  order: 1;
}
.sheet-form-order > .sheet-order-tel {
  order: 2;
}
label {
  display: inline-block;
  margin: 10px;
}

.btnJa {
  background-color: white;
  padding: 3px 15px 3px 15px;
  border-radius: 0px;
  border: 0px solid #A5BECC;
  box-shadow: 0px 5px 5px 0px rgba(0, 0, 0, 0.3);
  transition: all ease 0.3s;
}

.activeGender {
  background-color: #14C38E;
  padding: 3px 20px 3px 20px;
  border-radius: 10px;
  color: white;
  border: 1px solid #A5BECC;
  transform: translateY(-5px);
  box-shadow: 0px 10px 20px 2px rgba(0, 0, 0, 0.25);
  transition: all ease 0.3s;
}

.v-input__slot {
  top: -16px;
}

.notOpen {
  display: flex;
  height: 43vh;
  justify-content: center;
  align-items: center;
  flex-direction: column-reverse;
  font-size: 20px;
  font-weight: 100;
  text-decoration: underline;
}

.pinStyle {
  font-size: 30px;
  border-bottom: solid cornflowerblue 5px;
  ;
  width: 30px;
  display: flex;
  justify-content: center;
}

.swal-title {
  color: #000000 !important;
}

.swal-text {
  color: #000000 !important;
}

/* Background for LMG shop only */
.lmg-shop :deep(.v-application--wrap) {
  background-color: #f2f2f2 !important;
  background-image: none !important;
}

.lmg-shop :deep(.theme--light.v-chip),
.lmg-shop :deep(.theme--light.v-chip:not(.v-chip--active)) {
  background: #f2f2f2 !important;
  color: #000000 !important;
}

/* Button border-radius 0px for LMG shop only */
.lmg-shop :deep(.v-btn) {
  border-radius: 0px !important;
}

/* Ensure buttons in dialogs are clickable */
.lmg-shop :deep(.v-dialog .v-btn),
.lmg-shop :deep(.v-card-actions .v-btn) {
  pointer-events: auto !important;
  cursor: pointer !important;
  position: relative !important;
  z-index: 1 !important;
}

/* Label text color for LMG shop only */
.lmg-shop :deep(.v-label),
.lmg-shop :deep(.v-input label) {
  color: #2E263D !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Register/RegisterMember.vue